/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.Jd = (function() {

    /**
     * Namespace Jd.
     * @exports Jd
     * @namespace
     */
    var Jd = {};

    Jd.BetPool = (function() {

        /**
         * Properties of a BetPool.
         * @memberof Jd
         * @interface IBetPool
         * @property {number|null} [poolIx] BetPool poolIx
         * @property {number|null} [betCoinSum] BetPool betCoinSum
         * @property {Array.<Jd.BetPool.IBetInfo>|null} [betList] BetPool betList
         */

        /**
         * Constructs a new BetPool.
         * @memberof Jd
         * @classdesc Represents a BetPool.
         * @implements IBetPool
         * @constructor
         * @param {Jd.IBetPool=} [properties] Properties to set
         */
        function BetPool(properties) {
            this.betList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetPool poolIx.
         * @member {number} poolIx
         * @memberof Jd.BetPool
         * @instance
         */
        BetPool.prototype.poolIx = 0;

        /**
         * BetPool betCoinSum.
         * @member {number} betCoinSum
         * @memberof Jd.BetPool
         * @instance
         */
        BetPool.prototype.betCoinSum = 0;

        /**
         * BetPool betList.
         * @member {Array.<Jd.BetPool.IBetInfo>} betList
         * @memberof Jd.BetPool
         * @instance
         */
        BetPool.prototype.betList = $util.emptyArray;

        /**
         * Creates a new BetPool instance using the specified properties.
         * @function create
         * @memberof Jd.BetPool
         * @static
         * @param {Jd.IBetPool=} [properties] Properties to set
         * @returns {Jd.BetPool} BetPool instance
         */
        BetPool.create = function create(properties) {
            return new BetPool(properties);
        };

        /**
         * Encodes the specified BetPool message. Does not implicitly {@link Jd.BetPool.verify|verify} messages.
         * @function encode
         * @memberof Jd.BetPool
         * @static
         * @param {Jd.IBetPool} message BetPool message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetPool.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.poolIx != null && message.hasOwnProperty("poolIx"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.poolIx);
            if (message.betList != null && message.betList.length)
                for (var i = 0; i < message.betList.length; ++i)
                    $root.Jd.BetPool.BetInfo.encode(message.betList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.betCoinSum != null && message.hasOwnProperty("betCoinSum"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.betCoinSum);
            return writer;
        };

        /**
         * Encodes the specified BetPool message, length delimited. Does not implicitly {@link Jd.BetPool.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.BetPool
         * @static
         * @param {Jd.IBetPool} message BetPool message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetPool.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetPool message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.BetPool
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.BetPool} BetPool
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetPool.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.BetPool();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.poolIx = reader.uint32();
                    break;
                case 3:
                    message.betCoinSum = reader.double();
                    break;
                case 2:
                    if (!(message.betList && message.betList.length))
                        message.betList = [];
                    message.betList.push($root.Jd.BetPool.BetInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetPool message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.BetPool
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.BetPool} BetPool
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetPool.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetPool message.
         * @function verify
         * @memberof Jd.BetPool
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetPool.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.poolIx != null && message.hasOwnProperty("poolIx"))
                if (!$util.isInteger(message.poolIx))
                    return "poolIx: integer expected";
            if (message.betCoinSum != null && message.hasOwnProperty("betCoinSum"))
                if (typeof message.betCoinSum !== "number")
                    return "betCoinSum: number expected";
            if (message.betList != null && message.hasOwnProperty("betList")) {
                if (!Array.isArray(message.betList))
                    return "betList: array expected";
                for (var i = 0; i < message.betList.length; ++i) {
                    var error = $root.Jd.BetPool.BetInfo.verify(message.betList[i]);
                    if (error)
                        return "betList." + error;
                }
            }
            return null;
        };

        /**
         * Creates a BetPool message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.BetPool
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.BetPool} BetPool
         */
        BetPool.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.BetPool)
                return object;
            var message = new $root.Jd.BetPool();
            if (object.poolIx != null)
                message.poolIx = object.poolIx >>> 0;
            if (object.betCoinSum != null)
                message.betCoinSum = Number(object.betCoinSum);
            if (object.betList) {
                if (!Array.isArray(object.betList))
                    throw TypeError(".Jd.BetPool.betList: array expected");
                message.betList = [];
                for (var i = 0; i < object.betList.length; ++i) {
                    if (typeof object.betList[i] !== "object")
                        throw TypeError(".Jd.BetPool.betList: object expected");
                    message.betList[i] = $root.Jd.BetPool.BetInfo.fromObject(object.betList[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BetPool message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.BetPool
         * @static
         * @param {Jd.BetPool} message BetPool
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetPool.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.betList = [];
            if (options.defaults) {
                object.poolIx = 0;
                object.betCoinSum = 0;
            }
            if (message.poolIx != null && message.hasOwnProperty("poolIx"))
                object.poolIx = message.poolIx;
            if (message.betList && message.betList.length) {
                object.betList = [];
                for (var j = 0; j < message.betList.length; ++j)
                    object.betList[j] = $root.Jd.BetPool.BetInfo.toObject(message.betList[j], options);
            }
            if (message.betCoinSum != null && message.hasOwnProperty("betCoinSum"))
                object.betCoinSum = options.json && !isFinite(message.betCoinSum) ? String(message.betCoinSum) : message.betCoinSum;
            return object;
        };

        /**
         * Converts this BetPool to JSON.
         * @function toJSON
         * @memberof Jd.BetPool
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetPool.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        BetPool.BetInfo = (function() {

            /**
             * Properties of a BetInfo.
             * @memberof Jd.BetPool
             * @interface IBetInfo
             * @property {number|null} [seatId] BetInfo seatId
             * @property {number|null} [betCoin] BetInfo betCoin
             */

            /**
             * Constructs a new BetInfo.
             * @memberof Jd.BetPool
             * @classdesc Represents a BetInfo.
             * @implements IBetInfo
             * @constructor
             * @param {Jd.BetPool.IBetInfo=} [properties] Properties to set
             */
            function BetInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BetInfo seatId.
             * @member {number} seatId
             * @memberof Jd.BetPool.BetInfo
             * @instance
             */
            BetInfo.prototype.seatId = 0;

            /**
             * BetInfo betCoin.
             * @member {number} betCoin
             * @memberof Jd.BetPool.BetInfo
             * @instance
             */
            BetInfo.prototype.betCoin = 0;

            /**
             * Creates a new BetInfo instance using the specified properties.
             * @function create
             * @memberof Jd.BetPool.BetInfo
             * @static
             * @param {Jd.BetPool.IBetInfo=} [properties] Properties to set
             * @returns {Jd.BetPool.BetInfo} BetInfo instance
             */
            BetInfo.create = function create(properties) {
                return new BetInfo(properties);
            };

            /**
             * Encodes the specified BetInfo message. Does not implicitly {@link Jd.BetPool.BetInfo.verify|verify} messages.
             * @function encode
             * @memberof Jd.BetPool.BetInfo
             * @static
             * @param {Jd.BetPool.IBetInfo} message BetInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seatId != null && message.hasOwnProperty("seatId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.seatId);
                if (message.betCoin != null && message.hasOwnProperty("betCoin"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.betCoin);
                return writer;
            };

            /**
             * Encodes the specified BetInfo message, length delimited. Does not implicitly {@link Jd.BetPool.BetInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Jd.BetPool.BetInfo
             * @static
             * @param {Jd.BetPool.IBetInfo} message BetInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BetInfo message from the specified reader or buffer.
             * @function decode
             * @memberof Jd.BetPool.BetInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Jd.BetPool.BetInfo} BetInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.BetPool.BetInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.seatId = reader.uint32();
                        break;
                    case 2:
                        message.betCoin = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BetInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Jd.BetPool.BetInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Jd.BetPool.BetInfo} BetInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BetInfo message.
             * @function verify
             * @memberof Jd.BetPool.BetInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BetInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seatId != null && message.hasOwnProperty("seatId"))
                    if (!$util.isInteger(message.seatId))
                        return "seatId: integer expected";
                if (message.betCoin != null && message.hasOwnProperty("betCoin"))
                    if (!$util.isInteger(message.betCoin))
                        return "betCoin: integer expected";
                return null;
            };

            /**
             * Creates a BetInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Jd.BetPool.BetInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Jd.BetPool.BetInfo} BetInfo
             */
            BetInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.Jd.BetPool.BetInfo)
                    return object;
                var message = new $root.Jd.BetPool.BetInfo();
                if (object.seatId != null)
                    message.seatId = object.seatId >>> 0;
                if (object.betCoin != null)
                    message.betCoin = object.betCoin >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a BetInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Jd.BetPool.BetInfo
             * @static
             * @param {Jd.BetPool.BetInfo} message BetInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BetInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.seatId = 0;
                    object.betCoin = 0;
                }
                if (message.seatId != null && message.hasOwnProperty("seatId"))
                    object.seatId = message.seatId;
                if (message.betCoin != null && message.hasOwnProperty("betCoin"))
                    object.betCoin = message.betCoin;
                return object;
            };

            /**
             * Converts this BetInfo to JSON.
             * @function toJSON
             * @memberof Jd.BetPool.BetInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BetInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BetInfo;
        })();

        return BetPool;
    })();

    Jd.SeatInfo = (function() {

        /**
         * Properties of a SeatInfo.
         * @memberof Jd
         * @interface ISeatInfo
         * @property {number|null} [seatId] SeatInfo seatId
         * @property {number|null} [playerId] SeatInfo playerId
         * @property {Array.<number>|null} [cards] SeatInfo cards
         * @property {number|null} [cardType] SeatInfo cardType
         * @property {number|null} [cardPoint] SeatInfo cardPoint
         * @property {string|null} [userInfoJson] SeatInfo userInfoJson
         * @property {number|null} [coinBalance] SeatInfo coinBalance
         * @property {number|null} [betCoinSum] SeatInfo betCoinSum
         * @property {number|null} [currBet] SeatInfo currBet
         * @property {number|null} [balance] SeatInfo balance
         * @property {number|null} [state] SeatInfo state
         * @property {number|null} [accountBalance] SeatInfo accountBalance
         * @property {Jd.SeatInfo.ICarryInfo|null} [carryInfo] SeatInfo carryInfo
         * @property {string|null} [userJson] SeatInfo userJson
         */

        /**
         * Constructs a new SeatInfo.
         * @memberof Jd
         * @classdesc Represents a SeatInfo.
         * @implements ISeatInfo
         * @constructor
         * @param {Jd.ISeatInfo=} [properties] Properties to set
         */
        function SeatInfo(properties) {
            this.cards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SeatInfo seatId.
         * @member {number} seatId
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.seatId = 0;

        /**
         * SeatInfo playerId.
         * @member {number} playerId
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.playerId = 0;

        /**
         * SeatInfo cards.
         * @member {Array.<number>} cards
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.cards = $util.emptyArray;

        /**
         * SeatInfo cardType.
         * @member {number} cardType
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.cardType = 0;

        /**
         * SeatInfo cardPoint.
         * @member {number} cardPoint
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.cardPoint = 0;

        /**
         * SeatInfo userInfoJson.
         * @member {string} userInfoJson
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.userInfoJson = "";

        /**
         * SeatInfo coinBalance.
         * @member {number} coinBalance
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.coinBalance = 0;

        /**
         * SeatInfo betCoinSum.
         * @member {number} betCoinSum
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.betCoinSum = 0;

        /**
         * SeatInfo currBet.
         * @member {number} currBet
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.currBet = 0;

        /**
         * SeatInfo balance.
         * @member {number} balance
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.balance = 0;

        /**
         * SeatInfo state.
         * @member {number} state
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.state = 0;

        /**
         * SeatInfo accountBalance.
         * @member {number} accountBalance
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.accountBalance = 0;

        /**
         * SeatInfo carryInfo.
         * @member {Jd.SeatInfo.ICarryInfo|null|undefined} carryInfo
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.carryInfo = null;

        /**
         * SeatInfo userJson.
         * @member {string} userJson
         * @memberof Jd.SeatInfo
         * @instance
         */
        SeatInfo.prototype.userJson = "";

        /**
         * Creates a new SeatInfo instance using the specified properties.
         * @function create
         * @memberof Jd.SeatInfo
         * @static
         * @param {Jd.ISeatInfo=} [properties] Properties to set
         * @returns {Jd.SeatInfo} SeatInfo instance
         */
        SeatInfo.create = function create(properties) {
            return new SeatInfo(properties);
        };

        /**
         * Encodes the specified SeatInfo message. Does not implicitly {@link Jd.SeatInfo.verify|verify} messages.
         * @function encode
         * @memberof Jd.SeatInfo
         * @static
         * @param {Jd.ISeatInfo} message SeatInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.seatId);
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cards[i]);
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.playerId);
            if (message.cardType != null && message.hasOwnProperty("cardType"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.cardType);
            if (message.cardPoint != null && message.hasOwnProperty("cardPoint"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.cardPoint);
            if (message.userInfoJson != null && message.hasOwnProperty("userInfoJson"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.userInfoJson);
            if (message.betCoinSum != null && message.hasOwnProperty("betCoinSum"))
                writer.uint32(/* id 8, wireType 1 =*/65).double(message.betCoinSum);
            if (message.state != null && message.hasOwnProperty("state"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.state);
            if (message.currBet != null && message.hasOwnProperty("currBet"))
                writer.uint32(/* id 10, wireType 1 =*/81).double(message.currBet);
            if (message.carryInfo != null && message.hasOwnProperty("carryInfo"))
                $root.Jd.SeatInfo.CarryInfo.encode(message.carryInfo, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.balance != null && message.hasOwnProperty("balance"))
                writer.uint32(/* id 12, wireType 1 =*/97).double(message.balance);
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.userJson);
            if (message.accountBalance != null && message.hasOwnProperty("accountBalance"))
                writer.uint32(/* id 14, wireType 1 =*/113).double(message.accountBalance);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 16, wireType 1 =*/129).double(message.coinBalance);
            return writer;
        };

        /**
         * Encodes the specified SeatInfo message, length delimited. Does not implicitly {@link Jd.SeatInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.SeatInfo
         * @static
         * @param {Jd.ISeatInfo} message SeatInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SeatInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.SeatInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.SeatInfo} SeatInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.SeatInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.uint32();
                    break;
                case 3:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                case 5:
                    message.cardType = reader.int32();
                    break;
                case 6:
                    message.cardPoint = reader.int32();
                    break;
                case 7:
                    message.userInfoJson = reader.string();
                    break;
                case 16:
                    message.coinBalance = reader.double();
                    break;
                case 8:
                    message.betCoinSum = reader.double();
                    break;
                case 10:
                    message.currBet = reader.double();
                    break;
                case 12:
                    message.balance = reader.double();
                    break;
                case 9:
                    message.state = reader.int32();
                    break;
                case 14:
                    message.accountBalance = reader.double();
                    break;
                case 11:
                    message.carryInfo = $root.Jd.SeatInfo.CarryInfo.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.userJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SeatInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.SeatInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.SeatInfo} SeatInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SeatInfo message.
         * @function verify
         * @memberof Jd.SeatInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SeatInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            if (message.cardType != null && message.hasOwnProperty("cardType"))
                if (!$util.isInteger(message.cardType))
                    return "cardType: integer expected";
            if (message.cardPoint != null && message.hasOwnProperty("cardPoint"))
                if (!$util.isInteger(message.cardPoint))
                    return "cardPoint: integer expected";
            if (message.userInfoJson != null && message.hasOwnProperty("userInfoJson"))
                if (!$util.isString(message.userInfoJson))
                    return "userInfoJson: string expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (typeof message.coinBalance !== "number")
                    return "coinBalance: number expected";
            if (message.betCoinSum != null && message.hasOwnProperty("betCoinSum"))
                if (typeof message.betCoinSum !== "number")
                    return "betCoinSum: number expected";
            if (message.currBet != null && message.hasOwnProperty("currBet"))
                if (typeof message.currBet !== "number")
                    return "currBet: number expected";
            if (message.balance != null && message.hasOwnProperty("balance"))
                if (typeof message.balance !== "number")
                    return "balance: number expected";
            if (message.state != null && message.hasOwnProperty("state"))
                if (!$util.isInteger(message.state))
                    return "state: integer expected";
            if (message.accountBalance != null && message.hasOwnProperty("accountBalance"))
                if (typeof message.accountBalance !== "number")
                    return "accountBalance: number expected";
            if (message.carryInfo != null && message.hasOwnProperty("carryInfo")) {
                var error = $root.Jd.SeatInfo.CarryInfo.verify(message.carryInfo);
                if (error)
                    return "carryInfo." + error;
            }
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                if (!$util.isString(message.userJson))
                    return "userJson: string expected";
            return null;
        };

        /**
         * Creates a SeatInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.SeatInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.SeatInfo} SeatInfo
         */
        SeatInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.SeatInfo)
                return object;
            var message = new $root.Jd.SeatInfo();
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".Jd.SeatInfo.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            if (object.cardType != null)
                message.cardType = object.cardType | 0;
            if (object.cardPoint != null)
                message.cardPoint = object.cardPoint | 0;
            if (object.userInfoJson != null)
                message.userInfoJson = String(object.userInfoJson);
            if (object.coinBalance != null)
                message.coinBalance = Number(object.coinBalance);
            if (object.betCoinSum != null)
                message.betCoinSum = Number(object.betCoinSum);
            if (object.currBet != null)
                message.currBet = Number(object.currBet);
            if (object.balance != null)
                message.balance = Number(object.balance);
            if (object.state != null)
                message.state = object.state | 0;
            if (object.accountBalance != null)
                message.accountBalance = Number(object.accountBalance);
            if (object.carryInfo != null) {
                if (typeof object.carryInfo !== "object")
                    throw TypeError(".Jd.SeatInfo.carryInfo: object expected");
                message.carryInfo = $root.Jd.SeatInfo.CarryInfo.fromObject(object.carryInfo);
            }
            if (object.userJson != null)
                message.userJson = String(object.userJson);
            return message;
        };

        /**
         * Creates a plain object from a SeatInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.SeatInfo
         * @static
         * @param {Jd.SeatInfo} message SeatInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SeatInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.cards = [];
            if (options.defaults) {
                object.seatId = 0;
                object.playerId = 0;
                object.cardType = 0;
                object.cardPoint = 0;
                object.userInfoJson = "";
                object.betCoinSum = 0;
                object.state = 0;
                object.currBet = 0;
                object.carryInfo = null;
                object.balance = 0;
                object.userJson = "";
                object.accountBalance = 0;
                object.coinBalance = 0;
            }
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.cardType != null && message.hasOwnProperty("cardType"))
                object.cardType = message.cardType;
            if (message.cardPoint != null && message.hasOwnProperty("cardPoint"))
                object.cardPoint = message.cardPoint;
            if (message.userInfoJson != null && message.hasOwnProperty("userInfoJson"))
                object.userInfoJson = message.userInfoJson;
            if (message.betCoinSum != null && message.hasOwnProperty("betCoinSum"))
                object.betCoinSum = options.json && !isFinite(message.betCoinSum) ? String(message.betCoinSum) : message.betCoinSum;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.currBet != null && message.hasOwnProperty("currBet"))
                object.currBet = options.json && !isFinite(message.currBet) ? String(message.currBet) : message.currBet;
            if (message.carryInfo != null && message.hasOwnProperty("carryInfo"))
                object.carryInfo = $root.Jd.SeatInfo.CarryInfo.toObject(message.carryInfo, options);
            if (message.balance != null && message.hasOwnProperty("balance"))
                object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                object.userJson = message.userJson;
            if (message.accountBalance != null && message.hasOwnProperty("accountBalance"))
                object.accountBalance = options.json && !isFinite(message.accountBalance) ? String(message.accountBalance) : message.accountBalance;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
            return object;
        };

        /**
         * Converts this SeatInfo to JSON.
         * @function toJSON
         * @memberof Jd.SeatInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SeatInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SeatInfo.CarryInfo = (function() {

            /**
             * Properties of a CarryInfo.
             * @memberof Jd.SeatInfo
             * @interface ICarryInfo
             * @property {boolean|null} [autoCarry] CarryInfo autoCarry
             * @property {number|null} [coin] CarryInfo coin
             */

            /**
             * Constructs a new CarryInfo.
             * @memberof Jd.SeatInfo
             * @classdesc Represents a CarryInfo.
             * @implements ICarryInfo
             * @constructor
             * @param {Jd.SeatInfo.ICarryInfo=} [properties] Properties to set
             */
            function CarryInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CarryInfo autoCarry.
             * @member {boolean} autoCarry
             * @memberof Jd.SeatInfo.CarryInfo
             * @instance
             */
            CarryInfo.prototype.autoCarry = false;

            /**
             * CarryInfo coin.
             * @member {number} coin
             * @memberof Jd.SeatInfo.CarryInfo
             * @instance
             */
            CarryInfo.prototype.coin = 0;

            /**
             * Creates a new CarryInfo instance using the specified properties.
             * @function create
             * @memberof Jd.SeatInfo.CarryInfo
             * @static
             * @param {Jd.SeatInfo.ICarryInfo=} [properties] Properties to set
             * @returns {Jd.SeatInfo.CarryInfo} CarryInfo instance
             */
            CarryInfo.create = function create(properties) {
                return new CarryInfo(properties);
            };

            /**
             * Encodes the specified CarryInfo message. Does not implicitly {@link Jd.SeatInfo.CarryInfo.verify|verify} messages.
             * @function encode
             * @memberof Jd.SeatInfo.CarryInfo
             * @static
             * @param {Jd.SeatInfo.ICarryInfo} message CarryInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CarryInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.autoCarry != null && message.hasOwnProperty("autoCarry"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.autoCarry);
                if (message.coin != null && message.hasOwnProperty("coin"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.coin);
                return writer;
            };

            /**
             * Encodes the specified CarryInfo message, length delimited. Does not implicitly {@link Jd.SeatInfo.CarryInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Jd.SeatInfo.CarryInfo
             * @static
             * @param {Jd.SeatInfo.ICarryInfo} message CarryInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CarryInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CarryInfo message from the specified reader or buffer.
             * @function decode
             * @memberof Jd.SeatInfo.CarryInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Jd.SeatInfo.CarryInfo} CarryInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CarryInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.SeatInfo.CarryInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.autoCarry = reader.bool();
                        break;
                    case 2:
                        message.coin = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CarryInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Jd.SeatInfo.CarryInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Jd.SeatInfo.CarryInfo} CarryInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CarryInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CarryInfo message.
             * @function verify
             * @memberof Jd.SeatInfo.CarryInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CarryInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.autoCarry != null && message.hasOwnProperty("autoCarry"))
                    if (typeof message.autoCarry !== "boolean")
                        return "autoCarry: boolean expected";
                if (message.coin != null && message.hasOwnProperty("coin"))
                    if (typeof message.coin !== "number")
                        return "coin: number expected";
                return null;
            };

            /**
             * Creates a CarryInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Jd.SeatInfo.CarryInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Jd.SeatInfo.CarryInfo} CarryInfo
             */
            CarryInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.Jd.SeatInfo.CarryInfo)
                    return object;
                var message = new $root.Jd.SeatInfo.CarryInfo();
                if (object.autoCarry != null)
                    message.autoCarry = Boolean(object.autoCarry);
                if (object.coin != null)
                    message.coin = Number(object.coin);
                return message;
            };

            /**
             * Creates a plain object from a CarryInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Jd.SeatInfo.CarryInfo
             * @static
             * @param {Jd.SeatInfo.CarryInfo} message CarryInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CarryInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.autoCarry = false;
                    object.coin = 0;
                }
                if (message.autoCarry != null && message.hasOwnProperty("autoCarry"))
                    object.autoCarry = message.autoCarry;
                if (message.coin != null && message.hasOwnProperty("coin"))
                    object.coin = options.json && !isFinite(message.coin) ? String(message.coin) : message.coin;
                return object;
            };

            /**
             * Converts this CarryInfo to JSON.
             * @function toJSON
             * @memberof Jd.SeatInfo.CarryInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CarryInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CarryInfo;
        })();

        return SeatInfo;
    })();

    Jd.GameInfo = (function() {

        /**
         * Properties of a GameInfo.
         * @memberof Jd
         * @interface IGameInfo
         * @property {number|null} [roomId] GameInfo roomId
         * @property {number|null} [time] GameInfo time
         * @property {number|null} [maxPlayerCnt] GameInfo maxPlayerCnt
         * @property {number|null} [bankerSeatId] GameInfo bankerSeatId
         * @property {number|null} [state] GameInfo state
         * @property {number|null} [stateExpiredTime] GameInfo stateExpiredTime
         * @property {number|null} [stateDuration] GameInfo stateDuration
         * @property {number|null} [currentSeat] GameInfo currentSeat
         * @property {number|null} [currentLevelBet] GameInfo currentLevelBet
         * @property {number|null} [pot] GameInfo pot
         * @property {string|null} [roundId] GameInfo roundId
         * @property {string|null} [roomConf] GameInfo roomConf
         * @property {string|null} [goldConf] GameInfo goldConf
         * @property {Array.<Jd.IBetPool>|null} [poolList] GameInfo poolList
         * @property {Array.<Jd.ISeatInfo>|null} [seatList] GameInfo seatList
         */

        /**
         * Constructs a new GameInfo.
         * @memberof Jd
         * @classdesc Represents a GameInfo.
         * @implements IGameInfo
         * @constructor
         * @param {Jd.IGameInfo=} [properties] Properties to set
         */
        function GameInfo(properties) {
            this.poolList = [];
            this.seatList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameInfo roomId.
         * @member {number} roomId
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.roomId = 0;

        /**
         * GameInfo time.
         * @member {number} time
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.time = 0;

        /**
         * GameInfo maxPlayerCnt.
         * @member {number} maxPlayerCnt
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.maxPlayerCnt = 0;

        /**
         * GameInfo bankerSeatId.
         * @member {number} bankerSeatId
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.bankerSeatId = 0;

        /**
         * GameInfo state.
         * @member {number} state
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.state = 0;

        /**
         * GameInfo stateExpiredTime.
         * @member {number} stateExpiredTime
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.stateExpiredTime = 0;

        /**
         * GameInfo stateDuration.
         * @member {number} stateDuration
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.stateDuration = 0;

        /**
         * GameInfo currentSeat.
         * @member {number} currentSeat
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.currentSeat = 0;

        /**
         * GameInfo currentLevelBet.
         * @member {number} currentLevelBet
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.currentLevelBet = 0;

        /**
         * GameInfo pot.
         * @member {number} pot
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.pot = 0;

        /**
         * GameInfo roundId.
         * @member {string} roundId
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.roundId = "";

        /**
         * GameInfo roomConf.
         * @member {string} roomConf
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.roomConf = "";

        /**
         * GameInfo goldConf.
         * @member {string} goldConf
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.goldConf = "";

        /**
         * GameInfo poolList.
         * @member {Array.<Jd.IBetPool>} poolList
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.poolList = $util.emptyArray;

        /**
         * GameInfo seatList.
         * @member {Array.<Jd.ISeatInfo>} seatList
         * @memberof Jd.GameInfo
         * @instance
         */
        GameInfo.prototype.seatList = $util.emptyArray;

        /**
         * Creates a new GameInfo instance using the specified properties.
         * @function create
         * @memberof Jd.GameInfo
         * @static
         * @param {Jd.IGameInfo=} [properties] Properties to set
         * @returns {Jd.GameInfo} GameInfo instance
         */
        GameInfo.create = function create(properties) {
            return new GameInfo(properties);
        };

        /**
         * Encodes the specified GameInfo message. Does not implicitly {@link Jd.GameInfo.verify|verify} messages.
         * @function encode
         * @memberof Jd.GameInfo
         * @static
         * @param {Jd.IGameInfo} message GameInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomId);
            if (message.time != null && message.hasOwnProperty("time"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.time);
            if (message.maxPlayerCnt != null && message.hasOwnProperty("maxPlayerCnt"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.maxPlayerCnt);
            if (message.goldConf != null && message.hasOwnProperty("goldConf"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.goldConf);
            if (message.currentLevelBet != null && message.hasOwnProperty("currentLevelBet"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.currentLevelBet);
            if (message.pot != null && message.hasOwnProperty("pot"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.pot);
            if (message.roomConf != null && message.hasOwnProperty("roomConf"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.roomConf);
            if (message.bankerSeatId != null && message.hasOwnProperty("bankerSeatId"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.bankerSeatId);
            if (message.state != null && message.hasOwnProperty("state"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.state);
            if (message.stateExpiredTime != null && message.hasOwnProperty("stateExpiredTime"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.stateExpiredTime);
            if (message.currentSeat != null && message.hasOwnProperty("currentSeat"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.currentSeat);
            if (message.seatList != null && message.seatList.length)
                for (var i = 0; i < message.seatList.length; ++i)
                    $root.Jd.SeatInfo.encode(message.seatList[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.stateDuration != null && message.hasOwnProperty("stateDuration"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.stateDuration);
            if (message.poolList != null && message.poolList.length)
                for (var i = 0; i < message.poolList.length; ++i)
                    $root.Jd.BetPool.encode(message.poolList[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            if (message.roundId != null && message.hasOwnProperty("roundId"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.roundId);
            return writer;
        };

        /**
         * Encodes the specified GameInfo message, length delimited. Does not implicitly {@link Jd.GameInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.GameInfo
         * @static
         * @param {Jd.IGameInfo} message GameInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.GameInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.GameInfo} GameInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.GameInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomId = reader.int32();
                    break;
                case 3:
                    message.time = reader.int32();
                    break;
                case 4:
                    message.maxPlayerCnt = reader.int32();
                    break;
                case 9:
                    message.bankerSeatId = reader.int32();
                    break;
                case 10:
                    message.state = reader.int32();
                    break;
                case 11:
                    message.stateExpiredTime = reader.int32();
                    break;
                case 14:
                    message.stateDuration = reader.int32();
                    break;
                case 12:
                    message.currentSeat = reader.int32();
                    break;
                case 6:
                    message.currentLevelBet = reader.double();
                    break;
                case 7:
                    message.pot = reader.double();
                    break;
                case 16:
                    message.roundId = reader.string();
                    break;
                case 8:
                    message.roomConf = reader.string();
                    break;
                case 5:
                    message.goldConf = reader.string();
                    break;
                case 15:
                    if (!(message.poolList && message.poolList.length))
                        message.poolList = [];
                    message.poolList.push($root.Jd.BetPool.decode(reader, reader.uint32()));
                    break;
                case 13:
                    if (!(message.seatList && message.seatList.length))
                        message.seatList = [];
                    message.seatList.push($root.Jd.SeatInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.GameInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.GameInfo} GameInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameInfo message.
         * @function verify
         * @memberof Jd.GameInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isInteger(message.roomId))
                    return "roomId: integer expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time))
                    return "time: integer expected";
            if (message.maxPlayerCnt != null && message.hasOwnProperty("maxPlayerCnt"))
                if (!$util.isInteger(message.maxPlayerCnt))
                    return "maxPlayerCnt: integer expected";
            if (message.bankerSeatId != null && message.hasOwnProperty("bankerSeatId"))
                if (!$util.isInteger(message.bankerSeatId))
                    return "bankerSeatId: integer expected";
            if (message.state != null && message.hasOwnProperty("state"))
                if (!$util.isInteger(message.state))
                    return "state: integer expected";
            if (message.stateExpiredTime != null && message.hasOwnProperty("stateExpiredTime"))
                if (!$util.isInteger(message.stateExpiredTime))
                    return "stateExpiredTime: integer expected";
            if (message.stateDuration != null && message.hasOwnProperty("stateDuration"))
                if (!$util.isInteger(message.stateDuration))
                    return "stateDuration: integer expected";
            if (message.currentSeat != null && message.hasOwnProperty("currentSeat"))
                if (!$util.isInteger(message.currentSeat))
                    return "currentSeat: integer expected";
            if (message.currentLevelBet != null && message.hasOwnProperty("currentLevelBet"))
                if (typeof message.currentLevelBet !== "number")
                    return "currentLevelBet: number expected";
            if (message.pot != null && message.hasOwnProperty("pot"))
                if (typeof message.pot !== "number")
                    return "pot: number expected";
            if (message.roundId != null && message.hasOwnProperty("roundId"))
                if (!$util.isString(message.roundId))
                    return "roundId: string expected";
            if (message.roomConf != null && message.hasOwnProperty("roomConf"))
                if (!$util.isString(message.roomConf))
                    return "roomConf: string expected";
            if (message.goldConf != null && message.hasOwnProperty("goldConf"))
                if (!$util.isString(message.goldConf))
                    return "goldConf: string expected";
            if (message.poolList != null && message.hasOwnProperty("poolList")) {
                if (!Array.isArray(message.poolList))
                    return "poolList: array expected";
                for (var i = 0; i < message.poolList.length; ++i) {
                    var error = $root.Jd.BetPool.verify(message.poolList[i]);
                    if (error)
                        return "poolList." + error;
                }
            }
            if (message.seatList != null && message.hasOwnProperty("seatList")) {
                if (!Array.isArray(message.seatList))
                    return "seatList: array expected";
                for (var i = 0; i < message.seatList.length; ++i) {
                    var error = $root.Jd.SeatInfo.verify(message.seatList[i]);
                    if (error)
                        return "seatList." + error;
                }
            }
            return null;
        };

        /**
         * Creates a GameInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.GameInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.GameInfo} GameInfo
         */
        GameInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.GameInfo)
                return object;
            var message = new $root.Jd.GameInfo();
            if (object.roomId != null)
                message.roomId = object.roomId | 0;
            if (object.time != null)
                message.time = object.time | 0;
            if (object.maxPlayerCnt != null)
                message.maxPlayerCnt = object.maxPlayerCnt | 0;
            if (object.bankerSeatId != null)
                message.bankerSeatId = object.bankerSeatId | 0;
            if (object.state != null)
                message.state = object.state | 0;
            if (object.stateExpiredTime != null)
                message.stateExpiredTime = object.stateExpiredTime | 0;
            if (object.stateDuration != null)
                message.stateDuration = object.stateDuration | 0;
            if (object.currentSeat != null)
                message.currentSeat = object.currentSeat | 0;
            if (object.currentLevelBet != null)
                message.currentLevelBet = Number(object.currentLevelBet);
            if (object.pot != null)
                message.pot = Number(object.pot);
            if (object.roundId != null)
                message.roundId = String(object.roundId);
            if (object.roomConf != null)
                message.roomConf = String(object.roomConf);
            if (object.goldConf != null)
                message.goldConf = String(object.goldConf);
            if (object.poolList) {
                if (!Array.isArray(object.poolList))
                    throw TypeError(".Jd.GameInfo.poolList: array expected");
                message.poolList = [];
                for (var i = 0; i < object.poolList.length; ++i) {
                    if (typeof object.poolList[i] !== "object")
                        throw TypeError(".Jd.GameInfo.poolList: object expected");
                    message.poolList[i] = $root.Jd.BetPool.fromObject(object.poolList[i]);
                }
            }
            if (object.seatList) {
                if (!Array.isArray(object.seatList))
                    throw TypeError(".Jd.GameInfo.seatList: array expected");
                message.seatList = [];
                for (var i = 0; i < object.seatList.length; ++i) {
                    if (typeof object.seatList[i] !== "object")
                        throw TypeError(".Jd.GameInfo.seatList: object expected");
                    message.seatList[i] = $root.Jd.SeatInfo.fromObject(object.seatList[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GameInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.GameInfo
         * @static
         * @param {Jd.GameInfo} message GameInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.seatList = [];
                object.poolList = [];
            }
            if (options.defaults) {
                object.roomId = 0;
                object.time = 0;
                object.maxPlayerCnt = 0;
                object.goldConf = "";
                object.currentLevelBet = 0;
                object.pot = 0;
                object.roomConf = "";
                object.bankerSeatId = 0;
                object.state = 0;
                object.stateExpiredTime = 0;
                object.currentSeat = 0;
                object.stateDuration = 0;
                object.roundId = "";
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            if (message.maxPlayerCnt != null && message.hasOwnProperty("maxPlayerCnt"))
                object.maxPlayerCnt = message.maxPlayerCnt;
            if (message.goldConf != null && message.hasOwnProperty("goldConf"))
                object.goldConf = message.goldConf;
            if (message.currentLevelBet != null && message.hasOwnProperty("currentLevelBet"))
                object.currentLevelBet = options.json && !isFinite(message.currentLevelBet) ? String(message.currentLevelBet) : message.currentLevelBet;
            if (message.pot != null && message.hasOwnProperty("pot"))
                object.pot = options.json && !isFinite(message.pot) ? String(message.pot) : message.pot;
            if (message.roomConf != null && message.hasOwnProperty("roomConf"))
                object.roomConf = message.roomConf;
            if (message.bankerSeatId != null && message.hasOwnProperty("bankerSeatId"))
                object.bankerSeatId = message.bankerSeatId;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.stateExpiredTime != null && message.hasOwnProperty("stateExpiredTime"))
                object.stateExpiredTime = message.stateExpiredTime;
            if (message.currentSeat != null && message.hasOwnProperty("currentSeat"))
                object.currentSeat = message.currentSeat;
            if (message.seatList && message.seatList.length) {
                object.seatList = [];
                for (var j = 0; j < message.seatList.length; ++j)
                    object.seatList[j] = $root.Jd.SeatInfo.toObject(message.seatList[j], options);
            }
            if (message.stateDuration != null && message.hasOwnProperty("stateDuration"))
                object.stateDuration = message.stateDuration;
            if (message.poolList && message.poolList.length) {
                object.poolList = [];
                for (var j = 0; j < message.poolList.length; ++j)
                    object.poolList[j] = $root.Jd.BetPool.toObject(message.poolList[j], options);
            }
            if (message.roundId != null && message.hasOwnProperty("roundId"))
                object.roundId = message.roundId;
            return object;
        };

        /**
         * Converts this GameInfo to JSON.
         * @function toJSON
         * @memberof Jd.GameInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GameInfo;
    })();

    Jd.BetPoolNotify = (function() {

        /**
         * Properties of a BetPoolNotify.
         * @memberof Jd
         * @interface IBetPoolNotify
         * @property {Array.<Jd.IBetPool>|null} [poolList] BetPoolNotify poolList
         * @property {Array.<Jd.ISeatInfo>|null} [seatList] BetPoolNotify seatList
         */

        /**
         * Constructs a new BetPoolNotify.
         * @memberof Jd
         * @classdesc Represents a BetPoolNotify.
         * @implements IBetPoolNotify
         * @constructor
         * @param {Jd.IBetPoolNotify=} [properties] Properties to set
         */
        function BetPoolNotify(properties) {
            this.poolList = [];
            this.seatList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetPoolNotify poolList.
         * @member {Array.<Jd.IBetPool>} poolList
         * @memberof Jd.BetPoolNotify
         * @instance
         */
        BetPoolNotify.prototype.poolList = $util.emptyArray;

        /**
         * BetPoolNotify seatList.
         * @member {Array.<Jd.ISeatInfo>} seatList
         * @memberof Jd.BetPoolNotify
         * @instance
         */
        BetPoolNotify.prototype.seatList = $util.emptyArray;

        /**
         * Creates a new BetPoolNotify instance using the specified properties.
         * @function create
         * @memberof Jd.BetPoolNotify
         * @static
         * @param {Jd.IBetPoolNotify=} [properties] Properties to set
         * @returns {Jd.BetPoolNotify} BetPoolNotify instance
         */
        BetPoolNotify.create = function create(properties) {
            return new BetPoolNotify(properties);
        };

        /**
         * Encodes the specified BetPoolNotify message. Does not implicitly {@link Jd.BetPoolNotify.verify|verify} messages.
         * @function encode
         * @memberof Jd.BetPoolNotify
         * @static
         * @param {Jd.IBetPoolNotify} message BetPoolNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetPoolNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatList != null && message.seatList.length)
                for (var i = 0; i < message.seatList.length; ++i)
                    $root.Jd.SeatInfo.encode(message.seatList[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.poolList != null && message.poolList.length)
                for (var i = 0; i < message.poolList.length; ++i)
                    $root.Jd.BetPool.encode(message.poolList[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified BetPoolNotify message, length delimited. Does not implicitly {@link Jd.BetPoolNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.BetPoolNotify
         * @static
         * @param {Jd.IBetPoolNotify} message BetPoolNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetPoolNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetPoolNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.BetPoolNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.BetPoolNotify} BetPoolNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetPoolNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.BetPoolNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 15:
                    if (!(message.poolList && message.poolList.length))
                        message.poolList = [];
                    message.poolList.push($root.Jd.BetPool.decode(reader, reader.uint32()));
                    break;
                case 13:
                    if (!(message.seatList && message.seatList.length))
                        message.seatList = [];
                    message.seatList.push($root.Jd.SeatInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetPoolNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.BetPoolNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.BetPoolNotify} BetPoolNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetPoolNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetPoolNotify message.
         * @function verify
         * @memberof Jd.BetPoolNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetPoolNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.poolList != null && message.hasOwnProperty("poolList")) {
                if (!Array.isArray(message.poolList))
                    return "poolList: array expected";
                for (var i = 0; i < message.poolList.length; ++i) {
                    var error = $root.Jd.BetPool.verify(message.poolList[i]);
                    if (error)
                        return "poolList." + error;
                }
            }
            if (message.seatList != null && message.hasOwnProperty("seatList")) {
                if (!Array.isArray(message.seatList))
                    return "seatList: array expected";
                for (var i = 0; i < message.seatList.length; ++i) {
                    var error = $root.Jd.SeatInfo.verify(message.seatList[i]);
                    if (error)
                        return "seatList." + error;
                }
            }
            return null;
        };

        /**
         * Creates a BetPoolNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.BetPoolNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.BetPoolNotify} BetPoolNotify
         */
        BetPoolNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.BetPoolNotify)
                return object;
            var message = new $root.Jd.BetPoolNotify();
            if (object.poolList) {
                if (!Array.isArray(object.poolList))
                    throw TypeError(".Jd.BetPoolNotify.poolList: array expected");
                message.poolList = [];
                for (var i = 0; i < object.poolList.length; ++i) {
                    if (typeof object.poolList[i] !== "object")
                        throw TypeError(".Jd.BetPoolNotify.poolList: object expected");
                    message.poolList[i] = $root.Jd.BetPool.fromObject(object.poolList[i]);
                }
            }
            if (object.seatList) {
                if (!Array.isArray(object.seatList))
                    throw TypeError(".Jd.BetPoolNotify.seatList: array expected");
                message.seatList = [];
                for (var i = 0; i < object.seatList.length; ++i) {
                    if (typeof object.seatList[i] !== "object")
                        throw TypeError(".Jd.BetPoolNotify.seatList: object expected");
                    message.seatList[i] = $root.Jd.SeatInfo.fromObject(object.seatList[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BetPoolNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.BetPoolNotify
         * @static
         * @param {Jd.BetPoolNotify} message BetPoolNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetPoolNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.seatList = [];
                object.poolList = [];
            }
            if (message.seatList && message.seatList.length) {
                object.seatList = [];
                for (var j = 0; j < message.seatList.length; ++j)
                    object.seatList[j] = $root.Jd.SeatInfo.toObject(message.seatList[j], options);
            }
            if (message.poolList && message.poolList.length) {
                object.poolList = [];
                for (var j = 0; j < message.poolList.length; ++j)
                    object.poolList[j] = $root.Jd.BetPool.toObject(message.poolList[j], options);
            }
            return object;
        };

        /**
         * Converts this BetPoolNotify to JSON.
         * @function toJSON
         * @memberof Jd.BetPoolNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetPoolNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetPoolNotify;
    })();

    Jd.BankerNotify = (function() {

        /**
         * Properties of a BankerNotify.
         * @memberof Jd
         * @interface IBankerNotify
         * @property {number|null} [seatId] BankerNotify seatId
         */

        /**
         * Constructs a new BankerNotify.
         * @memberof Jd
         * @classdesc Represents a BankerNotify.
         * @implements IBankerNotify
         * @constructor
         * @param {Jd.IBankerNotify=} [properties] Properties to set
         */
        function BankerNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BankerNotify seatId.
         * @member {number} seatId
         * @memberof Jd.BankerNotify
         * @instance
         */
        BankerNotify.prototype.seatId = 0;

        /**
         * Creates a new BankerNotify instance using the specified properties.
         * @function create
         * @memberof Jd.BankerNotify
         * @static
         * @param {Jd.IBankerNotify=} [properties] Properties to set
         * @returns {Jd.BankerNotify} BankerNotify instance
         */
        BankerNotify.create = function create(properties) {
            return new BankerNotify(properties);
        };

        /**
         * Encodes the specified BankerNotify message. Does not implicitly {@link Jd.BankerNotify.verify|verify} messages.
         * @function encode
         * @memberof Jd.BankerNotify
         * @static
         * @param {Jd.IBankerNotify} message BankerNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.seatId);
            return writer;
        };

        /**
         * Encodes the specified BankerNotify message, length delimited. Does not implicitly {@link Jd.BankerNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.BankerNotify
         * @static
         * @param {Jd.IBankerNotify} message BankerNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BankerNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.BankerNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.BankerNotify} BankerNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.BankerNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BankerNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.BankerNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.BankerNotify} BankerNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BankerNotify message.
         * @function verify
         * @memberof Jd.BankerNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BankerNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            return null;
        };

        /**
         * Creates a BankerNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.BankerNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.BankerNotify} BankerNotify
         */
        BankerNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.BankerNotify)
                return object;
            var message = new $root.Jd.BankerNotify();
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a BankerNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.BankerNotify
         * @static
         * @param {Jd.BankerNotify} message BankerNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BankerNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.seatId = 0;
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            return object;
        };

        /**
         * Converts this BankerNotify to JSON.
         * @function toJSON
         * @memberof Jd.BankerNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BankerNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BankerNotify;
    })();

    Jd.DealCardNotify = (function() {

        /**
         * Properties of a DealCardNotify.
         * @memberof Jd
         * @interface IDealCardNotify
         * @property {Array.<Jd.ISeatInfo>|null} [seatList] DealCardNotify seatList
         * @property {number|null} [dealCnt] DealCardNotify dealCnt
         */

        /**
         * Constructs a new DealCardNotify.
         * @memberof Jd
         * @classdesc Represents a DealCardNotify.
         * @implements IDealCardNotify
         * @constructor
         * @param {Jd.IDealCardNotify=} [properties] Properties to set
         */
        function DealCardNotify(properties) {
            this.seatList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DealCardNotify seatList.
         * @member {Array.<Jd.ISeatInfo>} seatList
         * @memberof Jd.DealCardNotify
         * @instance
         */
        DealCardNotify.prototype.seatList = $util.emptyArray;

        /**
         * DealCardNotify dealCnt.
         * @member {number} dealCnt
         * @memberof Jd.DealCardNotify
         * @instance
         */
        DealCardNotify.prototype.dealCnt = 0;

        /**
         * Creates a new DealCardNotify instance using the specified properties.
         * @function create
         * @memberof Jd.DealCardNotify
         * @static
         * @param {Jd.IDealCardNotify=} [properties] Properties to set
         * @returns {Jd.DealCardNotify} DealCardNotify instance
         */
        DealCardNotify.create = function create(properties) {
            return new DealCardNotify(properties);
        };

        /**
         * Encodes the specified DealCardNotify message. Does not implicitly {@link Jd.DealCardNotify.verify|verify} messages.
         * @function encode
         * @memberof Jd.DealCardNotify
         * @static
         * @param {Jd.IDealCardNotify} message DealCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DealCardNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatList != null && message.seatList.length)
                for (var i = 0; i < message.seatList.length; ++i)
                    $root.Jd.SeatInfo.encode(message.seatList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.dealCnt != null && message.hasOwnProperty("dealCnt"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dealCnt);
            return writer;
        };

        /**
         * Encodes the specified DealCardNotify message, length delimited. Does not implicitly {@link Jd.DealCardNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.DealCardNotify
         * @static
         * @param {Jd.IDealCardNotify} message DealCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DealCardNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DealCardNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.DealCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.DealCardNotify} DealCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DealCardNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.DealCardNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.seatList && message.seatList.length))
                        message.seatList = [];
                    message.seatList.push($root.Jd.SeatInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.dealCnt = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DealCardNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.DealCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.DealCardNotify} DealCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DealCardNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DealCardNotify message.
         * @function verify
         * @memberof Jd.DealCardNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DealCardNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatList != null && message.hasOwnProperty("seatList")) {
                if (!Array.isArray(message.seatList))
                    return "seatList: array expected";
                for (var i = 0; i < message.seatList.length; ++i) {
                    var error = $root.Jd.SeatInfo.verify(message.seatList[i]);
                    if (error)
                        return "seatList." + error;
                }
            }
            if (message.dealCnt != null && message.hasOwnProperty("dealCnt"))
                if (!$util.isInteger(message.dealCnt))
                    return "dealCnt: integer expected";
            return null;
        };

        /**
         * Creates a DealCardNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.DealCardNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.DealCardNotify} DealCardNotify
         */
        DealCardNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.DealCardNotify)
                return object;
            var message = new $root.Jd.DealCardNotify();
            if (object.seatList) {
                if (!Array.isArray(object.seatList))
                    throw TypeError(".Jd.DealCardNotify.seatList: array expected");
                message.seatList = [];
                for (var i = 0; i < object.seatList.length; ++i) {
                    if (typeof object.seatList[i] !== "object")
                        throw TypeError(".Jd.DealCardNotify.seatList: object expected");
                    message.seatList[i] = $root.Jd.SeatInfo.fromObject(object.seatList[i]);
                }
            }
            if (object.dealCnt != null)
                message.dealCnt = object.dealCnt | 0;
            return message;
        };

        /**
         * Creates a plain object from a DealCardNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.DealCardNotify
         * @static
         * @param {Jd.DealCardNotify} message DealCardNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DealCardNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.seatList = [];
            if (options.defaults)
                object.dealCnt = 0;
            if (message.seatList && message.seatList.length) {
                object.seatList = [];
                for (var j = 0; j < message.seatList.length; ++j)
                    object.seatList[j] = $root.Jd.SeatInfo.toObject(message.seatList[j], options);
            }
            if (message.dealCnt != null && message.hasOwnProperty("dealCnt"))
                object.dealCnt = message.dealCnt;
            return object;
        };

        /**
         * Converts this DealCardNotify to JSON.
         * @function toJSON
         * @memberof Jd.DealCardNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DealCardNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DealCardNotify;
    })();

    Jd.GameSettle = (function() {

        /**
         * Properties of a GameSettle.
         * @memberof Jd
         * @interface IGameSettle
         * @property {Array.<Jd.ISeatInfo>|null} [seatList] GameSettle seatList
         * @property {Array.<Jd.GameSettle.IPoolSettle>|null} [poolList] GameSettle poolList
         * @property {number|null} [reason] GameSettle reason
         */

        /**
         * Constructs a new GameSettle.
         * @memberof Jd
         * @classdesc Represents a GameSettle.
         * @implements IGameSettle
         * @constructor
         * @param {Jd.IGameSettle=} [properties] Properties to set
         */
        function GameSettle(properties) {
            this.seatList = [];
            this.poolList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameSettle seatList.
         * @member {Array.<Jd.ISeatInfo>} seatList
         * @memberof Jd.GameSettle
         * @instance
         */
        GameSettle.prototype.seatList = $util.emptyArray;

        /**
         * GameSettle poolList.
         * @member {Array.<Jd.GameSettle.IPoolSettle>} poolList
         * @memberof Jd.GameSettle
         * @instance
         */
        GameSettle.prototype.poolList = $util.emptyArray;

        /**
         * GameSettle reason.
         * @member {number} reason
         * @memberof Jd.GameSettle
         * @instance
         */
        GameSettle.prototype.reason = 0;

        /**
         * Creates a new GameSettle instance using the specified properties.
         * @function create
         * @memberof Jd.GameSettle
         * @static
         * @param {Jd.IGameSettle=} [properties] Properties to set
         * @returns {Jd.GameSettle} GameSettle instance
         */
        GameSettle.create = function create(properties) {
            return new GameSettle(properties);
        };

        /**
         * Encodes the specified GameSettle message. Does not implicitly {@link Jd.GameSettle.verify|verify} messages.
         * @function encode
         * @memberof Jd.GameSettle
         * @static
         * @param {Jd.IGameSettle} message GameSettle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameSettle.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.poolList != null && message.poolList.length)
                for (var i = 0; i < message.poolList.length; ++i)
                    $root.Jd.GameSettle.PoolSettle.encode(message.poolList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.seatList != null && message.seatList.length)
                for (var i = 0; i < message.seatList.length; ++i)
                    $root.Jd.SeatInfo.encode(message.seatList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.reason != null && message.hasOwnProperty("reason"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.reason);
            return writer;
        };

        /**
         * Encodes the specified GameSettle message, length delimited. Does not implicitly {@link Jd.GameSettle.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.GameSettle
         * @static
         * @param {Jd.IGameSettle} message GameSettle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameSettle.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameSettle message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.GameSettle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.GameSettle} GameSettle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameSettle.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.GameSettle();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    if (!(message.seatList && message.seatList.length))
                        message.seatList = [];
                    message.seatList.push($root.Jd.SeatInfo.decode(reader, reader.uint32()));
                    break;
                case 1:
                    if (!(message.poolList && message.poolList.length))
                        message.poolList = [];
                    message.poolList.push($root.Jd.GameSettle.PoolSettle.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.reason = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameSettle message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.GameSettle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.GameSettle} GameSettle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameSettle.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameSettle message.
         * @function verify
         * @memberof Jd.GameSettle
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameSettle.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatList != null && message.hasOwnProperty("seatList")) {
                if (!Array.isArray(message.seatList))
                    return "seatList: array expected";
                for (var i = 0; i < message.seatList.length; ++i) {
                    var error = $root.Jd.SeatInfo.verify(message.seatList[i]);
                    if (error)
                        return "seatList." + error;
                }
            }
            if (message.poolList != null && message.hasOwnProperty("poolList")) {
                if (!Array.isArray(message.poolList))
                    return "poolList: array expected";
                for (var i = 0; i < message.poolList.length; ++i) {
                    var error = $root.Jd.GameSettle.PoolSettle.verify(message.poolList[i]);
                    if (error)
                        return "poolList." + error;
                }
            }
            if (message.reason != null && message.hasOwnProperty("reason"))
                if (!$util.isInteger(message.reason))
                    return "reason: integer expected";
            return null;
        };

        /**
         * Creates a GameSettle message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.GameSettle
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.GameSettle} GameSettle
         */
        GameSettle.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.GameSettle)
                return object;
            var message = new $root.Jd.GameSettle();
            if (object.seatList) {
                if (!Array.isArray(object.seatList))
                    throw TypeError(".Jd.GameSettle.seatList: array expected");
                message.seatList = [];
                for (var i = 0; i < object.seatList.length; ++i) {
                    if (typeof object.seatList[i] !== "object")
                        throw TypeError(".Jd.GameSettle.seatList: object expected");
                    message.seatList[i] = $root.Jd.SeatInfo.fromObject(object.seatList[i]);
                }
            }
            if (object.poolList) {
                if (!Array.isArray(object.poolList))
                    throw TypeError(".Jd.GameSettle.poolList: array expected");
                message.poolList = [];
                for (var i = 0; i < object.poolList.length; ++i) {
                    if (typeof object.poolList[i] !== "object")
                        throw TypeError(".Jd.GameSettle.poolList: object expected");
                    message.poolList[i] = $root.Jd.GameSettle.PoolSettle.fromObject(object.poolList[i]);
                }
            }
            if (object.reason != null)
                message.reason = object.reason | 0;
            return message;
        };

        /**
         * Creates a plain object from a GameSettle message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.GameSettle
         * @static
         * @param {Jd.GameSettle} message GameSettle
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameSettle.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.poolList = [];
                object.seatList = [];
            }
            if (options.defaults)
                object.reason = 0;
            if (message.poolList && message.poolList.length) {
                object.poolList = [];
                for (var j = 0; j < message.poolList.length; ++j)
                    object.poolList[j] = $root.Jd.GameSettle.PoolSettle.toObject(message.poolList[j], options);
            }
            if (message.seatList && message.seatList.length) {
                object.seatList = [];
                for (var j = 0; j < message.seatList.length; ++j)
                    object.seatList[j] = $root.Jd.SeatInfo.toObject(message.seatList[j], options);
            }
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            return object;
        };

        /**
         * Converts this GameSettle to JSON.
         * @function toJSON
         * @memberof Jd.GameSettle
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameSettle.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GameSettle.PoolSettle = (function() {

            /**
             * Properties of a PoolSettle.
             * @memberof Jd.GameSettle
             * @interface IPoolSettle
             * @property {Jd.IBetPool|null} [betPool] PoolSettle betPool
             * @property {number|null} [winCoin] PoolSettle winCoin
             * @property {number|null} [feeGold] PoolSettle feeGold
             * @property {number|null} [winnerSeatId] PoolSettle winnerSeatId
             */

            /**
             * Constructs a new PoolSettle.
             * @memberof Jd.GameSettle
             * @classdesc Represents a PoolSettle.
             * @implements IPoolSettle
             * @constructor
             * @param {Jd.GameSettle.IPoolSettle=} [properties] Properties to set
             */
            function PoolSettle(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PoolSettle betPool.
             * @member {Jd.IBetPool|null|undefined} betPool
             * @memberof Jd.GameSettle.PoolSettle
             * @instance
             */
            PoolSettle.prototype.betPool = null;

            /**
             * PoolSettle winCoin.
             * @member {number} winCoin
             * @memberof Jd.GameSettle.PoolSettle
             * @instance
             */
            PoolSettle.prototype.winCoin = 0;

            /**
             * PoolSettle feeGold.
             * @member {number} feeGold
             * @memberof Jd.GameSettle.PoolSettle
             * @instance
             */
            PoolSettle.prototype.feeGold = 0;

            /**
             * PoolSettle winnerSeatId.
             * @member {number} winnerSeatId
             * @memberof Jd.GameSettle.PoolSettle
             * @instance
             */
            PoolSettle.prototype.winnerSeatId = 0;

            /**
             * Creates a new PoolSettle instance using the specified properties.
             * @function create
             * @memberof Jd.GameSettle.PoolSettle
             * @static
             * @param {Jd.GameSettle.IPoolSettle=} [properties] Properties to set
             * @returns {Jd.GameSettle.PoolSettle} PoolSettle instance
             */
            PoolSettle.create = function create(properties) {
                return new PoolSettle(properties);
            };

            /**
             * Encodes the specified PoolSettle message. Does not implicitly {@link Jd.GameSettle.PoolSettle.verify|verify} messages.
             * @function encode
             * @memberof Jd.GameSettle.PoolSettle
             * @static
             * @param {Jd.GameSettle.IPoolSettle} message PoolSettle message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PoolSettle.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.betPool != null && message.hasOwnProperty("betPool"))
                    $root.Jd.BetPool.encode(message.betPool, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.winCoin != null && message.hasOwnProperty("winCoin"))
                    writer.uint32(/* id 4, wireType 1 =*/33).double(message.winCoin);
                if (message.feeGold != null && message.hasOwnProperty("feeGold"))
                    writer.uint32(/* id 6, wireType 1 =*/49).double(message.feeGold);
                if (message.winnerSeatId != null && message.hasOwnProperty("winnerSeatId"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.winnerSeatId);
                return writer;
            };

            /**
             * Encodes the specified PoolSettle message, length delimited. Does not implicitly {@link Jd.GameSettle.PoolSettle.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Jd.GameSettle.PoolSettle
             * @static
             * @param {Jd.GameSettle.IPoolSettle} message PoolSettle message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PoolSettle.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PoolSettle message from the specified reader or buffer.
             * @function decode
             * @memberof Jd.GameSettle.PoolSettle
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Jd.GameSettle.PoolSettle} PoolSettle
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PoolSettle.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.GameSettle.PoolSettle();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.betPool = $root.Jd.BetPool.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.winCoin = reader.double();
                        break;
                    case 6:
                        message.feeGold = reader.double();
                        break;
                    case 7:
                        message.winnerSeatId = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PoolSettle message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Jd.GameSettle.PoolSettle
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Jd.GameSettle.PoolSettle} PoolSettle
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PoolSettle.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PoolSettle message.
             * @function verify
             * @memberof Jd.GameSettle.PoolSettle
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PoolSettle.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.betPool != null && message.hasOwnProperty("betPool")) {
                    var error = $root.Jd.BetPool.verify(message.betPool);
                    if (error)
                        return "betPool." + error;
                }
                if (message.winCoin != null && message.hasOwnProperty("winCoin"))
                    if (typeof message.winCoin !== "number")
                        return "winCoin: number expected";
                if (message.feeGold != null && message.hasOwnProperty("feeGold"))
                    if (typeof message.feeGold !== "number")
                        return "feeGold: number expected";
                if (message.winnerSeatId != null && message.hasOwnProperty("winnerSeatId"))
                    if (!$util.isInteger(message.winnerSeatId))
                        return "winnerSeatId: integer expected";
                return null;
            };

            /**
             * Creates a PoolSettle message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Jd.GameSettle.PoolSettle
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Jd.GameSettle.PoolSettle} PoolSettle
             */
            PoolSettle.fromObject = function fromObject(object) {
                if (object instanceof $root.Jd.GameSettle.PoolSettle)
                    return object;
                var message = new $root.Jd.GameSettle.PoolSettle();
                if (object.betPool != null) {
                    if (typeof object.betPool !== "object")
                        throw TypeError(".Jd.GameSettle.PoolSettle.betPool: object expected");
                    message.betPool = $root.Jd.BetPool.fromObject(object.betPool);
                }
                if (object.winCoin != null)
                    message.winCoin = Number(object.winCoin);
                if (object.feeGold != null)
                    message.feeGold = Number(object.feeGold);
                if (object.winnerSeatId != null)
                    message.winnerSeatId = object.winnerSeatId | 0;
                return message;
            };

            /**
             * Creates a plain object from a PoolSettle message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Jd.GameSettle.PoolSettle
             * @static
             * @param {Jd.GameSettle.PoolSettle} message PoolSettle
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PoolSettle.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.betPool = null;
                    object.winCoin = 0;
                    object.feeGold = 0;
                    object.winnerSeatId = 0;
                }
                if (message.betPool != null && message.hasOwnProperty("betPool"))
                    object.betPool = $root.Jd.BetPool.toObject(message.betPool, options);
                if (message.winCoin != null && message.hasOwnProperty("winCoin"))
                    object.winCoin = options.json && !isFinite(message.winCoin) ? String(message.winCoin) : message.winCoin;
                if (message.feeGold != null && message.hasOwnProperty("feeGold"))
                    object.feeGold = options.json && !isFinite(message.feeGold) ? String(message.feeGold) : message.feeGold;
                if (message.winnerSeatId != null && message.hasOwnProperty("winnerSeatId"))
                    object.winnerSeatId = message.winnerSeatId;
                return object;
            };

            /**
             * Converts this PoolSettle to JSON.
             * @function toJSON
             * @memberof Jd.GameSettle.PoolSettle
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PoolSettle.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PoolSettle;
        })();

        return GameSettle;
    })();

    Jd.TimeoutNotify = (function() {

        /**
         * Properties of a TimeoutNotify.
         * @memberof Jd
         * @interface ITimeoutNotify
         * @property {number|null} [timeout] TimeoutNotify timeout
         * @property {number|null} [event] TimeoutNotify event
         * @property {number|null} [param] TimeoutNotify param
         * @property {number|null} [seatId] TimeoutNotify seatId
         * @property {number|null} [totalTimeout] TimeoutNotify totalTimeout
         */

        /**
         * Constructs a new TimeoutNotify.
         * @memberof Jd
         * @classdesc Represents a TimeoutNotify.
         * @implements ITimeoutNotify
         * @constructor
         * @param {Jd.ITimeoutNotify=} [properties] Properties to set
         */
        function TimeoutNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TimeoutNotify timeout.
         * @member {number} timeout
         * @memberof Jd.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.timeout = 0;

        /**
         * TimeoutNotify event.
         * @member {number} event
         * @memberof Jd.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.event = 0;

        /**
         * TimeoutNotify param.
         * @member {number} param
         * @memberof Jd.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.param = 0;

        /**
         * TimeoutNotify seatId.
         * @member {number} seatId
         * @memberof Jd.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.seatId = 0;

        /**
         * TimeoutNotify totalTimeout.
         * @member {number} totalTimeout
         * @memberof Jd.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.totalTimeout = 0;

        /**
         * Creates a new TimeoutNotify instance using the specified properties.
         * @function create
         * @memberof Jd.TimeoutNotify
         * @static
         * @param {Jd.ITimeoutNotify=} [properties] Properties to set
         * @returns {Jd.TimeoutNotify} TimeoutNotify instance
         */
        TimeoutNotify.create = function create(properties) {
            return new TimeoutNotify(properties);
        };

        /**
         * Encodes the specified TimeoutNotify message. Does not implicitly {@link Jd.TimeoutNotify.verify|verify} messages.
         * @function encode
         * @memberof Jd.TimeoutNotify
         * @static
         * @param {Jd.ITimeoutNotify} message TimeoutNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeoutNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.timeout);
            if (message.event != null && message.hasOwnProperty("event"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.event);
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.seatId);
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.totalTimeout);
            if (message.param != null && message.hasOwnProperty("param"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.param);
            return writer;
        };

        /**
         * Encodes the specified TimeoutNotify message, length delimited. Does not implicitly {@link Jd.TimeoutNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.TimeoutNotify
         * @static
         * @param {Jd.ITimeoutNotify} message TimeoutNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeoutNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TimeoutNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.TimeoutNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.TimeoutNotify} TimeoutNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeoutNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.TimeoutNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.timeout = reader.int32();
                    break;
                case 2:
                    message.event = reader.int32();
                    break;
                case 6:
                    message.param = reader.double();
                    break;
                case 3:
                    message.seatId = reader.uint32();
                    break;
                case 5:
                    message.totalTimeout = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TimeoutNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.TimeoutNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.TimeoutNotify} TimeoutNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeoutNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TimeoutNotify message.
         * @function verify
         * @memberof Jd.TimeoutNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TimeoutNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                if (!$util.isInteger(message.timeout))
                    return "timeout: integer expected";
            if (message.event != null && message.hasOwnProperty("event"))
                if (!$util.isInteger(message.event))
                    return "event: integer expected";
            if (message.param != null && message.hasOwnProperty("param"))
                if (typeof message.param !== "number")
                    return "param: number expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                if (!$util.isInteger(message.totalTimeout))
                    return "totalTimeout: integer expected";
            return null;
        };

        /**
         * Creates a TimeoutNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.TimeoutNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.TimeoutNotify} TimeoutNotify
         */
        TimeoutNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.TimeoutNotify)
                return object;
            var message = new $root.Jd.TimeoutNotify();
            if (object.timeout != null)
                message.timeout = object.timeout | 0;
            if (object.event != null)
                message.event = object.event | 0;
            if (object.param != null)
                message.param = Number(object.param);
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            if (object.totalTimeout != null)
                message.totalTimeout = object.totalTimeout | 0;
            return message;
        };

        /**
         * Creates a plain object from a TimeoutNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.TimeoutNotify
         * @static
         * @param {Jd.TimeoutNotify} message TimeoutNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TimeoutNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.timeout = 0;
                object.event = 0;
                object.seatId = 0;
                object.totalTimeout = 0;
                object.param = 0;
            }
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                object.timeout = message.timeout;
            if (message.event != null && message.hasOwnProperty("event"))
                object.event = message.event;
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                object.totalTimeout = message.totalTimeout;
            if (message.param != null && message.hasOwnProperty("param"))
                object.param = options.json && !isFinite(message.param) ? String(message.param) : message.param;
            return object;
        };

        /**
         * Converts this TimeoutNotify to JSON.
         * @function toJSON
         * @memberof Jd.TimeoutNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TimeoutNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TimeoutNotify;
    })();

    Jd.AckReq = (function() {

        /**
         * Properties of an AckReq.
         * @memberof Jd
         * @interface IAckReq
         * @property {number|null} [ackId] AckReq ackId
         */

        /**
         * Constructs a new AckReq.
         * @memberof Jd
         * @classdesc Represents an AckReq.
         * @implements IAckReq
         * @constructor
         * @param {Jd.IAckReq=} [properties] Properties to set
         */
        function AckReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AckReq ackId.
         * @member {number} ackId
         * @memberof Jd.AckReq
         * @instance
         */
        AckReq.prototype.ackId = 0;

        /**
         * Creates a new AckReq instance using the specified properties.
         * @function create
         * @memberof Jd.AckReq
         * @static
         * @param {Jd.IAckReq=} [properties] Properties to set
         * @returns {Jd.AckReq} AckReq instance
         */
        AckReq.create = function create(properties) {
            return new AckReq(properties);
        };

        /**
         * Encodes the specified AckReq message. Does not implicitly {@link Jd.AckReq.verify|verify} messages.
         * @function encode
         * @memberof Jd.AckReq
         * @static
         * @param {Jd.IAckReq} message AckReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AckReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ackId);
            return writer;
        };

        /**
         * Encodes the specified AckReq message, length delimited. Does not implicitly {@link Jd.AckReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.AckReq
         * @static
         * @param {Jd.IAckReq} message AckReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AckReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AckReq message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.AckReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.AckReq} AckReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AckReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.AckReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ackId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AckReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.AckReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.AckReq} AckReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AckReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AckReq message.
         * @function verify
         * @memberof Jd.AckReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AckReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                if (!$util.isInteger(message.ackId))
                    return "ackId: integer expected";
            return null;
        };

        /**
         * Creates an AckReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.AckReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.AckReq} AckReq
         */
        AckReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.AckReq)
                return object;
            var message = new $root.Jd.AckReq();
            if (object.ackId != null)
                message.ackId = object.ackId | 0;
            return message;
        };

        /**
         * Creates a plain object from an AckReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.AckReq
         * @static
         * @param {Jd.AckReq} message AckReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AckReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.ackId = 0;
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                object.ackId = message.ackId;
            return object;
        };

        /**
         * Converts this AckReq to JSON.
         * @function toJSON
         * @memberof Jd.AckReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AckReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AckReq;
    })();

    Jd.FoldReq = (function() {

        /**
         * Properties of a FoldReq.
         * @memberof Jd
         * @interface IFoldReq
         */

        /**
         * Constructs a new FoldReq.
         * @memberof Jd
         * @classdesc Represents a FoldReq.
         * @implements IFoldReq
         * @constructor
         * @param {Jd.IFoldReq=} [properties] Properties to set
         */
        function FoldReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new FoldReq instance using the specified properties.
         * @function create
         * @memberof Jd.FoldReq
         * @static
         * @param {Jd.IFoldReq=} [properties] Properties to set
         * @returns {Jd.FoldReq} FoldReq instance
         */
        FoldReq.create = function create(properties) {
            return new FoldReq(properties);
        };

        /**
         * Encodes the specified FoldReq message. Does not implicitly {@link Jd.FoldReq.verify|verify} messages.
         * @function encode
         * @memberof Jd.FoldReq
         * @static
         * @param {Jd.IFoldReq} message FoldReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FoldReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified FoldReq message, length delimited. Does not implicitly {@link Jd.FoldReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.FoldReq
         * @static
         * @param {Jd.IFoldReq} message FoldReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FoldReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FoldReq message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.FoldReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.FoldReq} FoldReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FoldReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.FoldReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FoldReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.FoldReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.FoldReq} FoldReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FoldReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FoldReq message.
         * @function verify
         * @memberof Jd.FoldReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FoldReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a FoldReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.FoldReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.FoldReq} FoldReq
         */
        FoldReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.FoldReq)
                return object;
            return new $root.Jd.FoldReq();
        };

        /**
         * Creates a plain object from a FoldReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.FoldReq
         * @static
         * @param {Jd.FoldReq} message FoldReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FoldReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this FoldReq to JSON.
         * @function toJSON
         * @memberof Jd.FoldReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FoldReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FoldReq;
    })();

    Jd.FoldRsp = (function() {

        /**
         * Properties of a FoldRsp.
         * @memberof Jd
         * @interface IFoldRsp
         * @property {number|null} [errNo] FoldRsp errNo
         */

        /**
         * Constructs a new FoldRsp.
         * @memberof Jd
         * @classdesc Represents a FoldRsp.
         * @implements IFoldRsp
         * @constructor
         * @param {Jd.IFoldRsp=} [properties] Properties to set
         */
        function FoldRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FoldRsp errNo.
         * @member {number} errNo
         * @memberof Jd.FoldRsp
         * @instance
         */
        FoldRsp.prototype.errNo = 0;

        /**
         * Creates a new FoldRsp instance using the specified properties.
         * @function create
         * @memberof Jd.FoldRsp
         * @static
         * @param {Jd.IFoldRsp=} [properties] Properties to set
         * @returns {Jd.FoldRsp} FoldRsp instance
         */
        FoldRsp.create = function create(properties) {
            return new FoldRsp(properties);
        };

        /**
         * Encodes the specified FoldRsp message. Does not implicitly {@link Jd.FoldRsp.verify|verify} messages.
         * @function encode
         * @memberof Jd.FoldRsp
         * @static
         * @param {Jd.IFoldRsp} message FoldRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FoldRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified FoldRsp message, length delimited. Does not implicitly {@link Jd.FoldRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.FoldRsp
         * @static
         * @param {Jd.IFoldRsp} message FoldRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FoldRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FoldRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.FoldRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.FoldRsp} FoldRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FoldRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.FoldRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FoldRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.FoldRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.FoldRsp} FoldRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FoldRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FoldRsp message.
         * @function verify
         * @memberof Jd.FoldRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FoldRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            return null;
        };

        /**
         * Creates a FoldRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.FoldRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.FoldRsp} FoldRsp
         */
        FoldRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.FoldRsp)
                return object;
            var message = new $root.Jd.FoldRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            return message;
        };

        /**
         * Creates a plain object from a FoldRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.FoldRsp
         * @static
         * @param {Jd.FoldRsp} message FoldRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FoldRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = 0;
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this FoldRsp to JSON.
         * @function toJSON
         * @memberof Jd.FoldRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FoldRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FoldRsp;
    })();

    Jd.FoldNotify = (function() {

        /**
         * Properties of a FoldNotify.
         * @memberof Jd
         * @interface IFoldNotify
         * @property {number|null} [seatId] FoldNotify seatId
         */

        /**
         * Constructs a new FoldNotify.
         * @memberof Jd
         * @classdesc Represents a FoldNotify.
         * @implements IFoldNotify
         * @constructor
         * @param {Jd.IFoldNotify=} [properties] Properties to set
         */
        function FoldNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FoldNotify seatId.
         * @member {number} seatId
         * @memberof Jd.FoldNotify
         * @instance
         */
        FoldNotify.prototype.seatId = 0;

        /**
         * Creates a new FoldNotify instance using the specified properties.
         * @function create
         * @memberof Jd.FoldNotify
         * @static
         * @param {Jd.IFoldNotify=} [properties] Properties to set
         * @returns {Jd.FoldNotify} FoldNotify instance
         */
        FoldNotify.create = function create(properties) {
            return new FoldNotify(properties);
        };

        /**
         * Encodes the specified FoldNotify message. Does not implicitly {@link Jd.FoldNotify.verify|verify} messages.
         * @function encode
         * @memberof Jd.FoldNotify
         * @static
         * @param {Jd.IFoldNotify} message FoldNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FoldNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.seatId);
            return writer;
        };

        /**
         * Encodes the specified FoldNotify message, length delimited. Does not implicitly {@link Jd.FoldNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.FoldNotify
         * @static
         * @param {Jd.IFoldNotify} message FoldNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FoldNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FoldNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.FoldNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.FoldNotify} FoldNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FoldNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.FoldNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 3:
                    message.seatId = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FoldNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.FoldNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.FoldNotify} FoldNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FoldNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FoldNotify message.
         * @function verify
         * @memberof Jd.FoldNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FoldNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            return null;
        };

        /**
         * Creates a FoldNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.FoldNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.FoldNotify} FoldNotify
         */
        FoldNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.FoldNotify)
                return object;
            var message = new $root.Jd.FoldNotify();
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a FoldNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.FoldNotify
         * @static
         * @param {Jd.FoldNotify} message FoldNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FoldNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.seatId = 0;
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            return object;
        };

        /**
         * Converts this FoldNotify to JSON.
         * @function toJSON
         * @memberof Jd.FoldNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FoldNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FoldNotify;
    })();

    Jd.BetReq = (function() {

        /**
         * Properties of a BetReq.
         * @memberof Jd
         * @interface IBetReq
         * @property {number|null} [betCoin] BetReq betCoin
         * @property {boolean|null} [allIn] BetReq allIn
         */

        /**
         * Constructs a new BetReq.
         * @memberof Jd
         * @classdesc Represents a BetReq.
         * @implements IBetReq
         * @constructor
         * @param {Jd.IBetReq=} [properties] Properties to set
         */
        function BetReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetReq betCoin.
         * @member {number} betCoin
         * @memberof Jd.BetReq
         * @instance
         */
        BetReq.prototype.betCoin = 0;

        /**
         * BetReq allIn.
         * @member {boolean} allIn
         * @memberof Jd.BetReq
         * @instance
         */
        BetReq.prototype.allIn = false;

        /**
         * Creates a new BetReq instance using the specified properties.
         * @function create
         * @memberof Jd.BetReq
         * @static
         * @param {Jd.IBetReq=} [properties] Properties to set
         * @returns {Jd.BetReq} BetReq instance
         */
        BetReq.create = function create(properties) {
            return new BetReq(properties);
        };

        /**
         * Encodes the specified BetReq message. Does not implicitly {@link Jd.BetReq.verify|verify} messages.
         * @function encode
         * @memberof Jd.BetReq
         * @static
         * @param {Jd.IBetReq} message BetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.betCoin != null && message.hasOwnProperty("betCoin"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.betCoin);
            if (message.allIn != null && message.hasOwnProperty("allIn"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.allIn);
            return writer;
        };

        /**
         * Encodes the specified BetReq message, length delimited. Does not implicitly {@link Jd.BetReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.BetReq
         * @static
         * @param {Jd.IBetReq} message BetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetReq message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.BetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.BetReq} BetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.BetReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.betCoin = reader.double();
                    break;
                case 2:
                    message.allIn = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.BetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.BetReq} BetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetReq message.
         * @function verify
         * @memberof Jd.BetReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.betCoin != null && message.hasOwnProperty("betCoin"))
                if (typeof message.betCoin !== "number")
                    return "betCoin: number expected";
            if (message.allIn != null && message.hasOwnProperty("allIn"))
                if (typeof message.allIn !== "boolean")
                    return "allIn: boolean expected";
            return null;
        };

        /**
         * Creates a BetReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.BetReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.BetReq} BetReq
         */
        BetReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.BetReq)
                return object;
            var message = new $root.Jd.BetReq();
            if (object.betCoin != null)
                message.betCoin = Number(object.betCoin);
            if (object.allIn != null)
                message.allIn = Boolean(object.allIn);
            return message;
        };

        /**
         * Creates a plain object from a BetReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.BetReq
         * @static
         * @param {Jd.BetReq} message BetReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.betCoin = 0;
                object.allIn = false;
            }
            if (message.betCoin != null && message.hasOwnProperty("betCoin"))
                object.betCoin = options.json && !isFinite(message.betCoin) ? String(message.betCoin) : message.betCoin;
            if (message.allIn != null && message.hasOwnProperty("allIn"))
                object.allIn = message.allIn;
            return object;
        };

        /**
         * Converts this BetReq to JSON.
         * @function toJSON
         * @memberof Jd.BetReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetReq;
    })();

    Jd.BetRsp = (function() {

        /**
         * Properties of a BetRsp.
         * @memberof Jd
         * @interface IBetRsp
         * @property {number|null} [errNo] BetRsp errNo
         */

        /**
         * Constructs a new BetRsp.
         * @memberof Jd
         * @classdesc Represents a BetRsp.
         * @implements IBetRsp
         * @constructor
         * @param {Jd.IBetRsp=} [properties] Properties to set
         */
        function BetRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetRsp errNo.
         * @member {number} errNo
         * @memberof Jd.BetRsp
         * @instance
         */
        BetRsp.prototype.errNo = 0;

        /**
         * Creates a new BetRsp instance using the specified properties.
         * @function create
         * @memberof Jd.BetRsp
         * @static
         * @param {Jd.IBetRsp=} [properties] Properties to set
         * @returns {Jd.BetRsp} BetRsp instance
         */
        BetRsp.create = function create(properties) {
            return new BetRsp(properties);
        };

        /**
         * Encodes the specified BetRsp message. Does not implicitly {@link Jd.BetRsp.verify|verify} messages.
         * @function encode
         * @memberof Jd.BetRsp
         * @static
         * @param {Jd.IBetRsp} message BetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified BetRsp message, length delimited. Does not implicitly {@link Jd.BetRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.BetRsp
         * @static
         * @param {Jd.IBetRsp} message BetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.BetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.BetRsp} BetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.BetRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.BetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.BetRsp} BetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetRsp message.
         * @function verify
         * @memberof Jd.BetRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            return null;
        };

        /**
         * Creates a BetRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.BetRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.BetRsp} BetRsp
         */
        BetRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.BetRsp)
                return object;
            var message = new $root.Jd.BetRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            return message;
        };

        /**
         * Creates a plain object from a BetRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.BetRsp
         * @static
         * @param {Jd.BetRsp} message BetRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = 0;
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this BetRsp to JSON.
         * @function toJSON
         * @memberof Jd.BetRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetRsp;
    })();

    Jd.BetNotify = (function() {

        /**
         * Properties of a BetNotify.
         * @memberof Jd
         * @interface IBetNotify
         * @property {number|null} [betCoin] BetNotify betCoin
         * @property {number|null} [seatId] BetNotify seatId
         * @property {number|null} [coinBalance] BetNotify coinBalance
         * @property {number|null} [accountBalance] BetNotify accountBalance
         * @property {number|null} [pot] BetNotify pot
         * @property {number|null} [state] BetNotify state
         */

        /**
         * Constructs a new BetNotify.
         * @memberof Jd
         * @classdesc Represents a BetNotify.
         * @implements IBetNotify
         * @constructor
         * @param {Jd.IBetNotify=} [properties] Properties to set
         */
        function BetNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetNotify betCoin.
         * @member {number} betCoin
         * @memberof Jd.BetNotify
         * @instance
         */
        BetNotify.prototype.betCoin = 0;

        /**
         * BetNotify seatId.
         * @member {number} seatId
         * @memberof Jd.BetNotify
         * @instance
         */
        BetNotify.prototype.seatId = 0;

        /**
         * BetNotify coinBalance.
         * @member {number} coinBalance
         * @memberof Jd.BetNotify
         * @instance
         */
        BetNotify.prototype.coinBalance = 0;

        /**
         * BetNotify accountBalance.
         * @member {number} accountBalance
         * @memberof Jd.BetNotify
         * @instance
         */
        BetNotify.prototype.accountBalance = 0;

        /**
         * BetNotify pot.
         * @member {number} pot
         * @memberof Jd.BetNotify
         * @instance
         */
        BetNotify.prototype.pot = 0;

        /**
         * BetNotify state.
         * @member {number} state
         * @memberof Jd.BetNotify
         * @instance
         */
        BetNotify.prototype.state = 0;

        /**
         * Creates a new BetNotify instance using the specified properties.
         * @function create
         * @memberof Jd.BetNotify
         * @static
         * @param {Jd.IBetNotify=} [properties] Properties to set
         * @returns {Jd.BetNotify} BetNotify instance
         */
        BetNotify.create = function create(properties) {
            return new BetNotify(properties);
        };

        /**
         * Encodes the specified BetNotify message. Does not implicitly {@link Jd.BetNotify.verify|verify} messages.
         * @function encode
         * @memberof Jd.BetNotify
         * @static
         * @param {Jd.IBetNotify} message BetNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.betCoin != null && message.hasOwnProperty("betCoin"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.betCoin);
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.seatId);
            if (message.pot != null && message.hasOwnProperty("pot"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.pot);
            if (message.state != null && message.hasOwnProperty("state"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.state);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 16, wireType 1 =*/129).double(message.coinBalance);
            if (message.accountBalance != null && message.hasOwnProperty("accountBalance"))
                writer.uint32(/* id 17, wireType 1 =*/137).double(message.accountBalance);
            return writer;
        };

        /**
         * Encodes the specified BetNotify message, length delimited. Does not implicitly {@link Jd.BetNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.BetNotify
         * @static
         * @param {Jd.IBetNotify} message BetNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.BetNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.BetNotify} BetNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.BetNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.betCoin = reader.double();
                    break;
                case 3:
                    message.seatId = reader.uint32();
                    break;
                case 16:
                    message.coinBalance = reader.double();
                    break;
                case 17:
                    message.accountBalance = reader.double();
                    break;
                case 4:
                    message.pot = reader.double();
                    break;
                case 6:
                    message.state = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.BetNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.BetNotify} BetNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetNotify message.
         * @function verify
         * @memberof Jd.BetNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.betCoin != null && message.hasOwnProperty("betCoin"))
                if (typeof message.betCoin !== "number")
                    return "betCoin: number expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (typeof message.coinBalance !== "number")
                    return "coinBalance: number expected";
            if (message.accountBalance != null && message.hasOwnProperty("accountBalance"))
                if (typeof message.accountBalance !== "number")
                    return "accountBalance: number expected";
            if (message.pot != null && message.hasOwnProperty("pot"))
                if (typeof message.pot !== "number")
                    return "pot: number expected";
            if (message.state != null && message.hasOwnProperty("state"))
                if (!$util.isInteger(message.state))
                    return "state: integer expected";
            return null;
        };

        /**
         * Creates a BetNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.BetNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.BetNotify} BetNotify
         */
        BetNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.BetNotify)
                return object;
            var message = new $root.Jd.BetNotify();
            if (object.betCoin != null)
                message.betCoin = Number(object.betCoin);
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            if (object.coinBalance != null)
                message.coinBalance = Number(object.coinBalance);
            if (object.accountBalance != null)
                message.accountBalance = Number(object.accountBalance);
            if (object.pot != null)
                message.pot = Number(object.pot);
            if (object.state != null)
                message.state = object.state >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a BetNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.BetNotify
         * @static
         * @param {Jd.BetNotify} message BetNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.betCoin = 0;
                object.seatId = 0;
                object.pot = 0;
                object.state = 0;
                object.coinBalance = 0;
                object.accountBalance = 0;
            }
            if (message.betCoin != null && message.hasOwnProperty("betCoin"))
                object.betCoin = options.json && !isFinite(message.betCoin) ? String(message.betCoin) : message.betCoin;
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.pot != null && message.hasOwnProperty("pot"))
                object.pot = options.json && !isFinite(message.pot) ? String(message.pot) : message.pot;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
            if (message.accountBalance != null && message.hasOwnProperty("accountBalance"))
                object.accountBalance = options.json && !isFinite(message.accountBalance) ? String(message.accountBalance) : message.accountBalance;
            return object;
        };

        /**
         * Converts this BetNotify to JSON.
         * @function toJSON
         * @memberof Jd.BetNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetNotify;
    })();

    Jd.CarryCoinReq = (function() {

        /**
         * Properties of a CarryCoinReq.
         * @memberof Jd
         * @interface ICarryCoinReq
         * @property {number|null} [coin] CarryCoinReq coin
         * @property {boolean|null} [autoCarry] CarryCoinReq autoCarry
         */

        /**
         * Constructs a new CarryCoinReq.
         * @memberof Jd
         * @classdesc Represents a CarryCoinReq.
         * @implements ICarryCoinReq
         * @constructor
         * @param {Jd.ICarryCoinReq=} [properties] Properties to set
         */
        function CarryCoinReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CarryCoinReq coin.
         * @member {number} coin
         * @memberof Jd.CarryCoinReq
         * @instance
         */
        CarryCoinReq.prototype.coin = 0;

        /**
         * CarryCoinReq autoCarry.
         * @member {boolean} autoCarry
         * @memberof Jd.CarryCoinReq
         * @instance
         */
        CarryCoinReq.prototype.autoCarry = false;

        /**
         * Creates a new CarryCoinReq instance using the specified properties.
         * @function create
         * @memberof Jd.CarryCoinReq
         * @static
         * @param {Jd.ICarryCoinReq=} [properties] Properties to set
         * @returns {Jd.CarryCoinReq} CarryCoinReq instance
         */
        CarryCoinReq.create = function create(properties) {
            return new CarryCoinReq(properties);
        };

        /**
         * Encodes the specified CarryCoinReq message. Does not implicitly {@link Jd.CarryCoinReq.verify|verify} messages.
         * @function encode
         * @memberof Jd.CarryCoinReq
         * @static
         * @param {Jd.ICarryCoinReq} message CarryCoinReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CarryCoinReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.autoCarry != null && message.hasOwnProperty("autoCarry"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.autoCarry);
            if (message.coin != null && message.hasOwnProperty("coin"))
                writer.uint32(/* id 16, wireType 1 =*/129).double(message.coin);
            return writer;
        };

        /**
         * Encodes the specified CarryCoinReq message, length delimited. Does not implicitly {@link Jd.CarryCoinReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.CarryCoinReq
         * @static
         * @param {Jd.ICarryCoinReq} message CarryCoinReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CarryCoinReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CarryCoinReq message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.CarryCoinReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.CarryCoinReq} CarryCoinReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CarryCoinReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.CarryCoinReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 16:
                    message.coin = reader.double();
                    break;
                case 1:
                    message.autoCarry = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CarryCoinReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.CarryCoinReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.CarryCoinReq} CarryCoinReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CarryCoinReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CarryCoinReq message.
         * @function verify
         * @memberof Jd.CarryCoinReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CarryCoinReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.coin != null && message.hasOwnProperty("coin"))
                if (typeof message.coin !== "number")
                    return "coin: number expected";
            if (message.autoCarry != null && message.hasOwnProperty("autoCarry"))
                if (typeof message.autoCarry !== "boolean")
                    return "autoCarry: boolean expected";
            return null;
        };

        /**
         * Creates a CarryCoinReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.CarryCoinReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.CarryCoinReq} CarryCoinReq
         */
        CarryCoinReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.CarryCoinReq)
                return object;
            var message = new $root.Jd.CarryCoinReq();
            if (object.coin != null)
                message.coin = Number(object.coin);
            if (object.autoCarry != null)
                message.autoCarry = Boolean(object.autoCarry);
            return message;
        };

        /**
         * Creates a plain object from a CarryCoinReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.CarryCoinReq
         * @static
         * @param {Jd.CarryCoinReq} message CarryCoinReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CarryCoinReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.autoCarry = false;
                object.coin = 0;
            }
            if (message.autoCarry != null && message.hasOwnProperty("autoCarry"))
                object.autoCarry = message.autoCarry;
            if (message.coin != null && message.hasOwnProperty("coin"))
                object.coin = options.json && !isFinite(message.coin) ? String(message.coin) : message.coin;
            return object;
        };

        /**
         * Converts this CarryCoinReq to JSON.
         * @function toJSON
         * @memberof Jd.CarryCoinReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CarryCoinReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CarryCoinReq;
    })();

    Jd.CarryCoinNotify = (function() {

        /**
         * Properties of a CarryCoinNotify.
         * @memberof Jd
         * @interface ICarryCoinNotify
         * @property {number|null} [coin] CarryCoinNotify coin
         * @property {number|null} [accountBalance] CarryCoinNotify accountBalance
         * @property {number|null} [seatId] CarryCoinNotify seatId
         */

        /**
         * Constructs a new CarryCoinNotify.
         * @memberof Jd
         * @classdesc Represents a CarryCoinNotify.
         * @implements ICarryCoinNotify
         * @constructor
         * @param {Jd.ICarryCoinNotify=} [properties] Properties to set
         */
        function CarryCoinNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CarryCoinNotify coin.
         * @member {number} coin
         * @memberof Jd.CarryCoinNotify
         * @instance
         */
        CarryCoinNotify.prototype.coin = 0;

        /**
         * CarryCoinNotify accountBalance.
         * @member {number} accountBalance
         * @memberof Jd.CarryCoinNotify
         * @instance
         */
        CarryCoinNotify.prototype.accountBalance = 0;

        /**
         * CarryCoinNotify seatId.
         * @member {number} seatId
         * @memberof Jd.CarryCoinNotify
         * @instance
         */
        CarryCoinNotify.prototype.seatId = 0;

        /**
         * Creates a new CarryCoinNotify instance using the specified properties.
         * @function create
         * @memberof Jd.CarryCoinNotify
         * @static
         * @param {Jd.ICarryCoinNotify=} [properties] Properties to set
         * @returns {Jd.CarryCoinNotify} CarryCoinNotify instance
         */
        CarryCoinNotify.create = function create(properties) {
            return new CarryCoinNotify(properties);
        };

        /**
         * Encodes the specified CarryCoinNotify message. Does not implicitly {@link Jd.CarryCoinNotify.verify|verify} messages.
         * @function encode
         * @memberof Jd.CarryCoinNotify
         * @static
         * @param {Jd.ICarryCoinNotify} message CarryCoinNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CarryCoinNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.seatId);
            if (message.coin != null && message.hasOwnProperty("coin"))
                writer.uint32(/* id 16, wireType 1 =*/129).double(message.coin);
            if (message.accountBalance != null && message.hasOwnProperty("accountBalance"))
                writer.uint32(/* id 17, wireType 1 =*/137).double(message.accountBalance);
            return writer;
        };

        /**
         * Encodes the specified CarryCoinNotify message, length delimited. Does not implicitly {@link Jd.CarryCoinNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.CarryCoinNotify
         * @static
         * @param {Jd.ICarryCoinNotify} message CarryCoinNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CarryCoinNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CarryCoinNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.CarryCoinNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.CarryCoinNotify} CarryCoinNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CarryCoinNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.CarryCoinNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 16:
                    message.coin = reader.double();
                    break;
                case 17:
                    message.accountBalance = reader.double();
                    break;
                case 3:
                    message.seatId = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CarryCoinNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.CarryCoinNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.CarryCoinNotify} CarryCoinNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CarryCoinNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CarryCoinNotify message.
         * @function verify
         * @memberof Jd.CarryCoinNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CarryCoinNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.coin != null && message.hasOwnProperty("coin"))
                if (typeof message.coin !== "number")
                    return "coin: number expected";
            if (message.accountBalance != null && message.hasOwnProperty("accountBalance"))
                if (typeof message.accountBalance !== "number")
                    return "accountBalance: number expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            return null;
        };

        /**
         * Creates a CarryCoinNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.CarryCoinNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.CarryCoinNotify} CarryCoinNotify
         */
        CarryCoinNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.CarryCoinNotify)
                return object;
            var message = new $root.Jd.CarryCoinNotify();
            if (object.coin != null)
                message.coin = Number(object.coin);
            if (object.accountBalance != null)
                message.accountBalance = Number(object.accountBalance);
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a CarryCoinNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.CarryCoinNotify
         * @static
         * @param {Jd.CarryCoinNotify} message CarryCoinNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CarryCoinNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.seatId = 0;
                object.coin = 0;
                object.accountBalance = 0;
            }
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.coin != null && message.hasOwnProperty("coin"))
                object.coin = options.json && !isFinite(message.coin) ? String(message.coin) : message.coin;
            if (message.accountBalance != null && message.hasOwnProperty("accountBalance"))
                object.accountBalance = options.json && !isFinite(message.accountBalance) ? String(message.accountBalance) : message.accountBalance;
            return object;
        };

        /**
         * Converts this CarryCoinNotify to JSON.
         * @function toJSON
         * @memberof Jd.CarryCoinNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CarryCoinNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CarryCoinNotify;
    })();

    Jd.AccountBalanceNotify = (function() {

        /**
         * Properties of an AccountBalanceNotify.
         * @memberof Jd
         * @interface IAccountBalanceNotify
         * @property {number|null} [coin] AccountBalanceNotify coin
         * @property {number|null} [seatId] AccountBalanceNotify seatId
         */

        /**
         * Constructs a new AccountBalanceNotify.
         * @memberof Jd
         * @classdesc Represents an AccountBalanceNotify.
         * @implements IAccountBalanceNotify
         * @constructor
         * @param {Jd.IAccountBalanceNotify=} [properties] Properties to set
         */
        function AccountBalanceNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AccountBalanceNotify coin.
         * @member {number} coin
         * @memberof Jd.AccountBalanceNotify
         * @instance
         */
        AccountBalanceNotify.prototype.coin = 0;

        /**
         * AccountBalanceNotify seatId.
         * @member {number} seatId
         * @memberof Jd.AccountBalanceNotify
         * @instance
         */
        AccountBalanceNotify.prototype.seatId = 0;

        /**
         * Creates a new AccountBalanceNotify instance using the specified properties.
         * @function create
         * @memberof Jd.AccountBalanceNotify
         * @static
         * @param {Jd.IAccountBalanceNotify=} [properties] Properties to set
         * @returns {Jd.AccountBalanceNotify} AccountBalanceNotify instance
         */
        AccountBalanceNotify.create = function create(properties) {
            return new AccountBalanceNotify(properties);
        };

        /**
         * Encodes the specified AccountBalanceNotify message. Does not implicitly {@link Jd.AccountBalanceNotify.verify|verify} messages.
         * @function encode
         * @memberof Jd.AccountBalanceNotify
         * @static
         * @param {Jd.IAccountBalanceNotify} message AccountBalanceNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AccountBalanceNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.seatId);
            if (message.coin != null && message.hasOwnProperty("coin"))
                writer.uint32(/* id 16, wireType 1 =*/129).double(message.coin);
            return writer;
        };

        /**
         * Encodes the specified AccountBalanceNotify message, length delimited. Does not implicitly {@link Jd.AccountBalanceNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.AccountBalanceNotify
         * @static
         * @param {Jd.IAccountBalanceNotify} message AccountBalanceNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AccountBalanceNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AccountBalanceNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.AccountBalanceNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.AccountBalanceNotify} AccountBalanceNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AccountBalanceNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.AccountBalanceNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 16:
                    message.coin = reader.double();
                    break;
                case 3:
                    message.seatId = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AccountBalanceNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.AccountBalanceNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.AccountBalanceNotify} AccountBalanceNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AccountBalanceNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AccountBalanceNotify message.
         * @function verify
         * @memberof Jd.AccountBalanceNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AccountBalanceNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.coin != null && message.hasOwnProperty("coin"))
                if (typeof message.coin !== "number")
                    return "coin: number expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            return null;
        };

        /**
         * Creates an AccountBalanceNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.AccountBalanceNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.AccountBalanceNotify} AccountBalanceNotify
         */
        AccountBalanceNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.AccountBalanceNotify)
                return object;
            var message = new $root.Jd.AccountBalanceNotify();
            if (object.coin != null)
                message.coin = Number(object.coin);
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an AccountBalanceNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.AccountBalanceNotify
         * @static
         * @param {Jd.AccountBalanceNotify} message AccountBalanceNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AccountBalanceNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.seatId = 0;
                object.coin = 0;
            }
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.coin != null && message.hasOwnProperty("coin"))
                object.coin = options.json && !isFinite(message.coin) ? String(message.coin) : message.coin;
            return object;
        };

        /**
         * Converts this AccountBalanceNotify to JSON.
         * @function toJSON
         * @memberof Jd.AccountBalanceNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AccountBalanceNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AccountBalanceNotify;
    })();

    Jd.CarryCoinRsp = (function() {

        /**
         * Properties of a CarryCoinRsp.
         * @memberof Jd
         * @interface ICarryCoinRsp
         * @property {number|null} [errNo] CarryCoinRsp errNo
         */

        /**
         * Constructs a new CarryCoinRsp.
         * @memberof Jd
         * @classdesc Represents a CarryCoinRsp.
         * @implements ICarryCoinRsp
         * @constructor
         * @param {Jd.ICarryCoinRsp=} [properties] Properties to set
         */
        function CarryCoinRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CarryCoinRsp errNo.
         * @member {number} errNo
         * @memberof Jd.CarryCoinRsp
         * @instance
         */
        CarryCoinRsp.prototype.errNo = 0;

        /**
         * Creates a new CarryCoinRsp instance using the specified properties.
         * @function create
         * @memberof Jd.CarryCoinRsp
         * @static
         * @param {Jd.ICarryCoinRsp=} [properties] Properties to set
         * @returns {Jd.CarryCoinRsp} CarryCoinRsp instance
         */
        CarryCoinRsp.create = function create(properties) {
            return new CarryCoinRsp(properties);
        };

        /**
         * Encodes the specified CarryCoinRsp message. Does not implicitly {@link Jd.CarryCoinRsp.verify|verify} messages.
         * @function encode
         * @memberof Jd.CarryCoinRsp
         * @static
         * @param {Jd.ICarryCoinRsp} message CarryCoinRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CarryCoinRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified CarryCoinRsp message, length delimited. Does not implicitly {@link Jd.CarryCoinRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.CarryCoinRsp
         * @static
         * @param {Jd.ICarryCoinRsp} message CarryCoinRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CarryCoinRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CarryCoinRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.CarryCoinRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.CarryCoinRsp} CarryCoinRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CarryCoinRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.CarryCoinRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CarryCoinRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.CarryCoinRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.CarryCoinRsp} CarryCoinRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CarryCoinRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CarryCoinRsp message.
         * @function verify
         * @memberof Jd.CarryCoinRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CarryCoinRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            return null;
        };

        /**
         * Creates a CarryCoinRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.CarryCoinRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.CarryCoinRsp} CarryCoinRsp
         */
        CarryCoinRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.CarryCoinRsp)
                return object;
            var message = new $root.Jd.CarryCoinRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            return message;
        };

        /**
         * Creates a plain object from a CarryCoinRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.CarryCoinRsp
         * @static
         * @param {Jd.CarryCoinRsp} message CarryCoinRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CarryCoinRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = 0;
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this CarryCoinRsp to JSON.
         * @function toJSON
         * @memberof Jd.CarryCoinRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CarryCoinRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CarryCoinRsp;
    })();

    Jd.CarryWantsNotify = (function() {

        /**
         * Properties of a CarryWantsNotify.
         * @memberof Jd
         * @interface ICarryWantsNotify
         */

        /**
         * Constructs a new CarryWantsNotify.
         * @memberof Jd
         * @classdesc Represents a CarryWantsNotify.
         * @implements ICarryWantsNotify
         * @constructor
         * @param {Jd.ICarryWantsNotify=} [properties] Properties to set
         */
        function CarryWantsNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new CarryWantsNotify instance using the specified properties.
         * @function create
         * @memberof Jd.CarryWantsNotify
         * @static
         * @param {Jd.ICarryWantsNotify=} [properties] Properties to set
         * @returns {Jd.CarryWantsNotify} CarryWantsNotify instance
         */
        CarryWantsNotify.create = function create(properties) {
            return new CarryWantsNotify(properties);
        };

        /**
         * Encodes the specified CarryWantsNotify message. Does not implicitly {@link Jd.CarryWantsNotify.verify|verify} messages.
         * @function encode
         * @memberof Jd.CarryWantsNotify
         * @static
         * @param {Jd.ICarryWantsNotify} message CarryWantsNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CarryWantsNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified CarryWantsNotify message, length delimited. Does not implicitly {@link Jd.CarryWantsNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Jd.CarryWantsNotify
         * @static
         * @param {Jd.ICarryWantsNotify} message CarryWantsNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CarryWantsNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CarryWantsNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Jd.CarryWantsNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Jd.CarryWantsNotify} CarryWantsNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CarryWantsNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Jd.CarryWantsNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CarryWantsNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Jd.CarryWantsNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Jd.CarryWantsNotify} CarryWantsNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CarryWantsNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CarryWantsNotify message.
         * @function verify
         * @memberof Jd.CarryWantsNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CarryWantsNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a CarryWantsNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Jd.CarryWantsNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Jd.CarryWantsNotify} CarryWantsNotify
         */
        CarryWantsNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Jd.CarryWantsNotify)
                return object;
            return new $root.Jd.CarryWantsNotify();
        };

        /**
         * Creates a plain object from a CarryWantsNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Jd.CarryWantsNotify
         * @static
         * @param {Jd.CarryWantsNotify} message CarryWantsNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CarryWantsNotify.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this CarryWantsNotify to JSON.
         * @function toJSON
         * @memberof Jd.CarryWantsNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CarryWantsNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CarryWantsNotify;
    })();

    return Jd;
})();

module.exports = $root;
